import { v4 as uuid } from 'uuid';
import { h } from 'vue';
import Paragraph from '@/components/Global/Paragraph.vue';
import OpenItem from '@/components/Global/OpenItem.vue';
import { font, textInRow, boldText, renderBoldText, textCenter, styleText, verticalCenter } from '@/utils/texts';
import HomeCareImg from '@/components/Global/HomeCareImg.vue';
import Processing from '@/components/Global/Processing.vue';
// import HomeCareImgWithText from '@/components/Global/HomeCareImgWithText.vue';

export const hypetensionCol = [
  {
    header: '欄位一',
    prop: 'col1',
    width: 100,
  },
  {
    header: '欄位二',
    prop: 'col2',
  },
  {
    header: '欄位三',
    prop: 'col3',
  },
  {
    header: '欄位四',
    prop: 'col4',
  },
];

export const HighRiskUnderStandingContent = {
  colGroup: [
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },

    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '母親',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          style: textCenter,
          tdStyle: verticalCenter,
          t: '胎兒、胎盤羊水',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          style: textCenter,
          tdStyle: verticalCenter,
          t: '孕前',
        },
        {
          style: textCenter,
          tdStyle: verticalCenter,
          t: '孕期',
        },
        {
          render: h(Paragraph, {
            wording: [
              {
                render: h('div', { style: font({ fontWeight: '700' }) }, [h('p', '1.胎兒生長遲滯')]),
              },

              {
                type: 'normal',
                text: ['2.胎兒窘迫'],
                style: {
                  marginTop: 0,
                },
              },
              {
                render: h('div', { style: font({ fontWeight: '700' }) }, [h('p', '3.早產'), h('p', '4.多胞胎妊娠')]),
              },
              {
                type: 'normal',
                text: ['5.巨嬰', '6.過期妊娠', '7.產程遲滯', '8.羊水過多、過少'],
                style: {
                  marginTop: 0,
                },
              },
              {
                render: h('div', { style: font({ fontWeight: '700' }) }, [
                  h('p', '9.早產早期破水'),
                  h('p', '10.前置胎盤'),
                  h('p', '11.胎盤早期剝離'),
                ]),
              },
            ],
          }),
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '1.腦血管疾病',
                  '2.心臟疾病',
                  '3.慢性高血壓',
                  '4.氣喘',
                  '5.肝病',
                  '6.腎臟病',
                  '7.糖尿病',
                  '8.癲癇',
                ],
                style: {
                  marginTop: 0,
                },
              },
              {
                render: h('div', { style: font({ fontWeight: '700' }) }, [
                  h('p', '9.貧血'),
                  h('p', '10.傳染性疾病'),
                  h('p', '11.青少女及高齡者'),
                ]),
              },
              {
                type: 'normal',
                text: ['12.體重過重或過輕者'],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),
        },
        {
          render: h(Paragraph, {
            wording: [
              // {
              //   type: 'normal',
              //   text: ['1.妊娠高血壓', '2.子癲症、子癲前症', '3.甲狀腺機能亢進', '4.妊娠糖尿病', '5.全身性紅斑狼瘡'],
              //   style: {
              //     marginTop: 0,
              //   },
              // },
              {
                render: h('div', { style: font({ fontWeight: '700' }) }, [
                  h('p', '1.妊娠高血壓'),
                  h('p', '2.子癲症、子癲前症'),
                  h('p', '3.甲狀腺機能亢進'),
                  h('p', '4.妊娠糖尿病'),
                  h('p', '5.全身性紅斑狼瘡'),
                ]),
              },
            ],
          }),
        },
      ],
    },
  ],
};

export const HighRiskWeightContent = {
  colGroup: [
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },

    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [
    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: '孕期體重增加指引',
          style: {
            ...textCenter,
            fontWeight: 700,
          },
          tdStyle: {
            ...verticalCenter,
          },
          colspan: 4,
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: [
            styleText('單胞胎孕婦', {
              ...textCenter,
              fontWeight: 700,
            }),
            styleText('孕前體重等級', {
              ...textCenter,
              fontWeight: 700,
            }),
          ],
        },
        {
          style: textCenter,
          tdStyle: verticalCenter,
          render: h(
            'p',
            {
              style: {
                ...textCenter,
                fontWeight: 700,
              },
            },
            [
              h('span', '孕前體重指數（kg / m'),
              h(
                'sup',
                {
                  style: {
                    position: 'relative',
                    top: '-3px',
                  },
                },
                '2',
              ),
              h('span', '）'),
            ],
          ),
        },
        {
          style: {
            ...textCenter,
            fontWeight: 700,
          },
          tdStyle: verticalCenter,
          t: '建議體重增加',
        },
        {
          style: {
            ...textCenter,
            fontWeight: 700,
          },
          tdStyle: verticalCenter,
          t: '第二、三孕期每週增加重量',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '體重過輕',
        },
        {
          t: '<18.5',
        },
        {
          t: '12.5至18公斤',
        },
        {
          t: '0.5公斤',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '普通的',
        },
        {
          t: '18.5至24.9',
        },
        {
          t: '11.5到16公斤',
        },
        {
          t: '0.5公斤',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '超重',
        },
        {
          t: '25.0至29.9',
        },
        {
          t: '7到11.5公斤',
        },
        {
          t: '0.3公斤',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '肥胖（I類）',
        },
        {
          t: '>30.0',
        },
        {
          t: '5至9公斤',
        },
        {
          t: '0.25公斤',
        },
      ],
    },

    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: [
            styleText('雙胞胎孕婦', {
              ...textCenter,
              fontWeight: 700,
            }),
            styleText('孕前體重等級', {
              ...textCenter,
              fontWeight: 700,
            }),
          ],
        },
        {
          style: {
            ...textCenter,
            fontWeight: 700,
          },
          tdStyle: verticalCenter,
          render: h(
            'p',
            {
              style: {
                ...textCenter,
                fontWeight: 700,
              },
            },
            [
              h('span', '孕前體重指數（kg / m'),
              h(
                'sup',
                {
                  style: {
                    position: 'relative',
                    top: '-3px',
                  },
                },
                '2',
              ),
              h('span', '）'),
            ],
          ),
        },
        {
          style: {
            ...textCenter,
            fontWeight: 700,
          },
          tdStyle: verticalCenter,
          t: '建議體重增加',
          colspan: 2,
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '普通的',
        },
        {
          t: '18.5至24.9',
        },
        {
          t: '16.8到24.5公斤',
          colspan: 2,
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '超重',
        },
        {
          t: '25.0至29.9',
        },
        {
          t: '14.1到22.7公斤',
          colspan: 2,
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '肥胖（I類）',
        },
        {
          t: '>30.0',
        },
        {
          t: '11.4到19.1公斤',
          colspan: 2,
        },
      ],
    },
  ],
};

export const HighRiskHypetensionContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 300,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '',
        },
        {
          t: '診斷標準參考',
        },
        {
          t: '辨別方式',
        },
        {
          t: '常見症狀',
        },

        {
          t: '治療方式',
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '妊娠高血壓',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '在懷孕20週以後才確診的高血壓即為妊娠高血壓。',
        },
        {
          t: '血壓高。',
        },
        {
          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '噁心。',
                  '嘔吐。',
                  '頭痛(持續性或劇烈性)。',
                  '視力模糊。',
                  '呼吸困難。',
                  '右上腹痛。',
                  '嚴重者肝功能異常。',
                  '血小板低下。',
                  '水腫。',
                  '抽筋或癲癇發作。',
                  '胎兒生長遲滯。',
                  '胎盤早期脫離。',
                  '早產。',
                ],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),
          rowspan: 4,
        },
        {
          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '一般輕微高血壓症狀建議：',
                  '1.在家臥床休息，保持情緒穩定，注意胎動情形。',
                  '2.自行常規測量記錄血壓，依醫師指示服用藥物治療。',
                  '3.自覺有異常主動就診或密切門診追蹤。',
                ],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          style: textCenter,
          tdStyle: verticalCenter,
          t: [styleText('子癲前症', textCenter), styleText('(妊娠毒血症)', textCenter)],
        },

        { t: '懷孕20週以後，六個小時測量血壓，出現兩次>140/90mmHg/day，同時合併有蛋白尿。' },

        // boldText('血壓高又合併蛋白尿(肝腎功能)'),
        { t: '血壓高又合併蛋白尿(肝腎功能)', rowspan: 2 },
        {
          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '1.治療高血壓如口服降血壓藥物。',
                  '2.給予硫酸鎂預防痙攣發生，須注意藥物濃度及副作用，若仍無法改善，則會選擇適當時機生產。',
                  '若治療妥當，居家照顧建議：',
                  '1.規則服用藥物且定時返診追蹤。',
                  '2.每日測量記錄血壓三次(標準值：<140/90mmHg)。',
                  '3.如有頭痛、視力模糊、上腹痛等症狀請立即就醫。',
                ],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '重度子癲前症',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        { t: '血壓>160/110mmHg、蛋白尿>3-5g/day、24小時尿量<300cc。' },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '子癲症',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        { t: '子癲前症症狀加上全身性的痙攣即為子癲症。' },
        { t: '血壓高+蛋白尿+癲癇發作' },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '預防',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '若為高風險族群，預防方法是在懷孕16週之前開始服用低劑量阿斯匹靈，直到36週時停止，可以減少75-80%發生子癲前症的風險，並且減少子宮內胎兒生長遲緩及胎兒死亡率。目前建議子癲前症篩檢的高風險可以使用阿斯匹靈。',
          colspan: 4,
        },
      ],
    },
  ],
};

export const HighRiskThyroidContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '甲狀腺功能異常',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '甲狀腺有新陳代謝、生長、發育等功能，而碘是甲狀腺激素的重要成分之一，碘若過量會易導致自體免疫疾病發生。',
                  '甲狀腺亢進指製造過多的甲狀腺激素；甲狀腺低下指缺乏甲狀腺激素。若懷孕前即有甲狀腺機能亢進或低下等症狀，建議有效控制後再懷孕，才能避免孕期及生產期間的危險性。',
                ],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),
          colspan: 3,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '好發族群',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '生育年齡的女性。',
          colspan: 3,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '',
        },
        {
          t: '症狀',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '處置方式',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '危險性',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '孕期甲狀腺機能亢進',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '疲勞、體重減輕、怕熱、多汗、不規律的心悸、情緒不穩、食慾增加、呼吸困難、眼球突出、心律不整等。',
        },
        {
          t: '懷孕過程中應定期追蹤甲狀腺的功能，以隨時評估母親及胎兒的狀況。',
        },
        {
          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '子癲前症、心肺衰竭、胎盤剝離、感染、貧血，甚至是嚴重的甲狀腺風暴。',
                  '早產、新生兒甲狀腺功能亢進、子宮內胎兒發育遲緩，流產、胎死腹中。',
                ],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '孕期甲狀腺機能低下',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '疲勞、嗜睡、怕冷、皮膚乾燥、體重增加、水腫、肌肉抽筋、心跳變慢、便秘，高血壓等。',
        },
        {
          t: '治療方法為定時補充甲狀腺素即可。',
        },
        {
          t: '新生兒甲狀腺功能低下、新生兒畸形、智力不足、體重不足等。流產，死產的機率高。',
        },
      ],
    },
  ],
};

export const HighRiskDiabetesContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },

    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '妊娠糖尿病診斷方式',
          style: textCenter,
          tdStyle: verticalCenter,
          rowspan: 2,
        },
        {
          t: '方式A',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: [
            '▶1.在24-28週進行口服50公克葡萄糖耐受性測驗一小時後抽血，如果 >140mg/dL則被視為高風險族群，就要進行▶2.。',
            '▶2.100公克耐糖測試：空腹喝下糖水後1小時→兩小時→三小時進行抽血，如果有兩次以上超標即被診斷為妊娠糖尿病。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '方式B',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '直接做75公克耐糖測試：空腹喝下糖水後1小時→兩小時進行抽血，如果有一次以上超標即被診斷為妊娠糖尿病。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '居家治療',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: [
            '1.定時自我監測記錄血糖，空腹血糖值：80-105 mg/dL；飯後兩小時血糖值：100-120 mg/dL，於返診時將資料提供給醫師參考。',
            '2.向專業營養師營養諮詢：',
          ],

          render: h(Paragraph, {
            wording: [
              {
                type: 'normal',
                text: [
                  '1.定時自我監測記錄血糖，空腹血糖值：80-105 mg/dL；飯後兩小時血糖值：100-120 mg/dL，於返診時將資料提供給醫師參考。',
                  '2.向專業營養師營養諮詢：',
                ],
                style: {
                  marginTop: 0,
                },
              },
              {
                type: 'normal-indent',
                text: [
                  '(1)了解正確的飲食觀念，如烹調方式、控制熱量攝取。',
                  '(2)採高纖維、新鮮多醣類食物為主，能延緩血糖的上升。',
                  '(3)可加糙米、胚芽米、燕麥片等膳食纖維來取代米飯，減少澱粉類攝取，有助血糖穩定。',
                  '(4)少量多餐、採三次正餐加點心的方式較佳，注意避免甜食及油炸食物。',
                  '(5)睡前點心應含蛋白質與碳水化合物，以預防夜間低血糖、避免尿酮發生。',
                ],
                style: {
                  marginTop: 0,
                },
              },
              {
                type: 'normal',
                text: [
                  '3.適量運動、體重控制：',
                  '每天至少三十分鐘以上運動如散步、游泳、孕婦瑜珈等，可增加母親周邊肌肉對身體胰島素之敏感度，有助於血糖控制正常範圍。若出現規則性宮縮，建議暫緩運動或改變運動型態，以避免早產。',
                ],
                style: {
                  marginTop: 0,
                },
              },
            ],
          }),

          colspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '藥物治療',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: [
            '1.胰島素注射：治療首選，因分子量大，幾乎不會通過胎盤。',
            '2.口服降血糖藥物：方便、患者接受度高，亦可作替代治療，實證中不會造成胎兒異常，不過若控制不佳，則須使用注射型胰島素。',
          ],
          colspan: 2,
        },
      ],
    },
  ],
};

export const HighRiskLupusContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },

    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '紅斑性狼瘡',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '是一種慢性且無法治癒的自體免疫疾病，多發生於育齡婦女，發生原因不明，但會影響體內的多種器官，如心臟、腎臟、關節、神經系統及免疫統等。發生率為0.05％，約有35.5％的病患會在懷孕期惡化。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '症狀',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: [
            '在沒有外來病菌侵犯的情形下，身體卻產生抗體對付自身的組織，引起發炎反應，破壞身體器官。',
            '主要症狀有蝴蝶斑、口腔潰爛、尿蛋白過高、溶血性貧血、血小板過少以及腎臟疾病、不知原因抽筋等。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '危險性',
          style: textCenter,
          tdStyle: verticalCenter,
          rowspan: 2,
        },
        {
          t: '母體',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '紅斑性狼瘡會侵犯到血管，造成免疫力會降低，有高機率自然流產或早產，也可能會使胎兒生產遲緩，甚至破壞胎盤功能，造成胎死腹中。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '胎兒',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '新生兒可能會發生新生兒狼瘡症候群，出生時身上有暫時的紅斑、血小板低下等問題，出生後6個月後會消失，嚴重的話會有永久性心室心房完全阻斷，須永久使用心臟節律器。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '處置方式',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '紅斑性狼瘡患者大多使用類固醇藥物治療，在適當的治療下，仍可擁有不錯的生活品質。建議服藥期間不要懷孕，等疾病症狀穩定後再考慮懷孕。懷孕後，必須密切觀察臨床症狀，且依照醫師指示服藥，千萬不可自行增減藥物。',
        },
      ],
    },
  ],
};

export const HighRiskMultipleBirthContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },

    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '多胞胎',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '多胞胎可以分為同卵及異卵，胎數越多，也會影響子宮所能承載的空間容量，甚至縮短孕期，風險相對增加，如單一胎兒生長遲滯或是雙胞胎輸血症候群，建議產檢時謹慎評估，勿過度勞累，注意早產徵兆，並且定期產檢、追蹤胎兒的生長狀況。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '常見族群',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '黑人、高齡(尤其是35至39歲自然受孕)、家族有多胞胎史、進行人工生殖技術者。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '發生率',
          style: textCenter,
          tdStyle: verticalCenter,
          rowspan: 2,
          colspan: 2,
        },
        {
          t: '同卵雙胞胎發生率為4/1,000。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '異卵雙胞胎發生率則約1/100。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '影響',
          rowspan: 2,
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '孕婦',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '妊娠劇吐、貧血、妊娠高血壓、子癇前症、前置胎盤、羊水過多、產前產後出血、早產。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '胎兒',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '胎兒先天異常、流產率、胎死腹中，胎兒過小、雙胞胎輸血症候群風險。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '雙胞胎輸血症候群',
          colspan: 2,
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '只要是共用同一個胎盤的同卵多胞胎都可能發生「雙胞胎輸血症候群」，使得兩個胎兒有相通的血管及不平衡的血流問題。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '治療方式',
          colspan: 2,
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: [
            '1.傳統方式：透過反覆的羊水抽吸，來達到子宮內減壓的目的，以免羊水過多導致子宮收縮。',
            '2.子宮內胎兒內視鏡雷射治療(主流)：使用內視鏡穿到子宮內，並用雷射將胎兒間相通的血管凝固、阻斷流通。治療後，2個寶寶同時存活率可提高至55-65%，至少1個寶寶存活率約85-90%。存活的胎兒腦性麻痺機率從50%降到5-10%。',
          ],
        },
      ],
    },
  ],
};

export const HighRiskPlacentaPrevia1Content = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },

    {
      id: uuid(),
      width: 400,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),

      texts: [
        {
          t: '前置胎盤',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '指胎盤著床的位置接近或蓋住子宮頸的出入口而影響正常的自然生產，通常都發生在子宮內有受過創傷或手術所引起。',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '危險因子',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '孕婦曾懷孕多次、曾做過流產手術或子宮手術、前胎剖腹產。',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '常見症狀',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '無痛性出血。',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '診斷方式',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '通常在妊娠7-8個月才會確立診斷。',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '診斷工具',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '陰道超音波為主軸，腹部超音波為參考。',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '類型',
          rowspan: 4,
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '部分性',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '胎盤部分擋住子宮頸口。',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '完全性',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '完全擋住子宮頸口。',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '邊緣性',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '胎盤位於子宮頸口的旁邊。',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '低位性',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '胎盤位置比較低。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '禁忌',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '確診後不能有性行為、不宜泡澡或泡溫泉、不宜騎機車（較易因顛簸而出血），也不能內診或做陰道超音波。',
        },
      ],
    },
  ],
};

export const HighRiskPlacentaPrevia2Content = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },

    {
      id: uuid(),
      width: 400,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '胎盤早期剝離',
          style: textCenter,
          colspan: 2,
        },
        {
          t: '胎兒還沒娩出前，胎盤部分或完全從子宮壁剝離，即為胎盤早期剝離，為產科急症。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '危險因子',
          style: textCenter,
          colspan: 2,
        },
        {
          t: '高血壓或妊娠高血壓、外力撞擊（例如：車禍）。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '典型症狀',
          style: textCenter,
          colspan: 2,
        },
        {
          t: '腹部持續性疼痛、子宮很硬、陰道出血。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '診斷方式',
          style: textCenter,
          colspan: 2,
        },
        {
          t: '超音波及搭配臨床症狀如腹痛來加以判斷。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '影響',
          style: textCenter,
          colspan: 2,
        },
        {
          t: [
            '若只是小範圍的剝離，且胎心音穩定，孕婦大多不會有症狀，可再持續觀察。',
            '嚴重則會使胎兒缺血、缺氧，甚至可能胎死腹中。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '預防',
          style: textCenter,
          colspan: 2,
        },
        {
          t: '避免遭到撞擊；患有高血壓或妊娠高血壓的孕婦，應控制血壓與規則服藥。',
        },
      ],
    },
  ],
};

export const understandFoodType = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '食物種類',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '食物參考建議',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '全榖根莖類',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '糙米、米、飯、麵條、饅頭、全麥黑麵包、紅豆、綠豆、地瓜。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '蔬菜類',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '各種各樣蔬菜(葉菜類、瓜類、海產類蔬菜、豆莢類深綠色、紅黃色蔬菜、菇類)',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '水果類',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '各種新鮮水果。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '豆魚肉蛋類',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '黃豆類製品、素肉類、各種肉類、海鮮類、雞蛋。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '奶類',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '牛奶、優酪乳、乳酪、各種奶類製品',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '油脂與堅果',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '植物性油脂、堅果(核果)類(花生、腰果、開心果、芝麻)、酪梨。',
        },
      ],
    },
  ],
};

export const understandFoodNutrition = {
  colGroup: [
    {
      id: uuid(),
      width: 80,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 70,
    },
    {
      id: uuid(),
      width: 150,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '',
        },
        {
          t: ' 懷孕第一期',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 4,
        },
        {
          t: ' 懷孕二、三期',
        },
        {
          t: '份量說明',
          style: textCenter,
          tdStyle: verticalCenter,
          rowspan: 4,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        // {
        //   t: [
        //     '生活活動強度',
        //     '(Kcal/day)',
        //   ],
        //   style: textCenter,

        //   rowspan: 2,
        // },
        {
          t: [styleText('生活活動強度', textCenter), styleText('(Kcal/day)', textCenter)],
          style: textCenter,
          tdStyle: verticalCenter,
          rowspan: 2,
        },
        {
          t: '低(臥床)',
        },
        {
          t: '稍低',
        },
        {
          t: '適度',
        },
        {
          t: '高',
        },
        {
          t: '增加300大卡',
          rowspan: 2,
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '1550',
        },
        {
          t: '1800',
        },
        {
          t: '2050',
        },
        {
          t: '2300',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '六大類食物',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '懷孕第一期',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 4,
        },
        {
          t: '懷孕二、三期',
        },
        // {
        //   t: '3',
        // },
        // {
        //   t: '3.5',
        // },
        // {
        //   t: '4',
        // },
        // {
        //   t: '+1.2/碗',
        // },
        // {
        //   t: '1碗=飯 1碗=麵 2碗=中型饅頭 1個=薄片吐司4片',
        // },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '全穀根莖類(碗)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '2.5-3',
        },
        {
          t: '3',
        },
        {
          t: '3.5',
        },
        {
          t: '4',
        },
        {
          t: '+1.2/碗',
        },
        {
          t: '1碗=飯 1碗=麵 2碗=中型饅頭 1個=薄片吐司4片',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '豆魚肉蛋類(份)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '2-3',
        },
        {
          t: '3',
        },
        {
          t: '3.5',
        },
        {
          t: '4',
        },
        {
          t: '-',
        },
        {
          t: '1份=熟的肉或家禽或魚肉30公克(生重約1兩)=蛋1顆=豆腐1塊(4小格)',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '蔬菜類(碟)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '3',
        },
        {
          t: '3',
        },
        {
          t: '4',
        },
        {
          t: '4',
        },
        {
          t: '+1/2碗',
        },
        {
          t: '1碟=蔬菜生重100公克(約3兩)',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '水果類(個)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '2',
        },
        {
          t: '3',
        },
        {
          t: '3',
        },
        {
          t: '3',
        },
        {
          t: '-',
        },
        {
          t: '1個=橘子1顆=土芭樂1個(約1個棒球大)',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '奶類(杯)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '1-2',
        },
        {
          t: '2',
        },
        {
          t: '2',
        },
        {
          t: '2',
        },
        {
          t: '+1杯',
        },
        {
          t: '1杯=牛奶240cc=優酪乳200cc=3平匙奶粉',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '油脂類(湯匙)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '2',
        },
        {
          t: '2',
        },
        {
          t: '2.5',
        },
        {
          t: '3',
        },
        {
          t: '-',
        },
        {
          t: '1湯匙=15公克烹調用油',
        },
      ],
    },
  ],
};

export const drugEffectContent = {
  colGroup: [
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
  ],

  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '藥物',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '型態',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '作用',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '副作用',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '注意事項',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
  ],

  body: [
    {
      id: uuid(),
      texts: [
        {
          t: 'Nifedipine(Adalat)',
        },
        {
          t: '舌下給藥或口服。',
        },
        {
          t: '可讓子宮平滑肌鬆弛。使用後效果快速，經常為子宮收縮時的緊急用藥。',
        },
        {
          t: '面潮紅、發汗、頭痛、呼吸困難、低血壓、頻脈、噁心等。',
        },
        {
          t: '服用此藥物後會使血壓降低、臉紅、溫熱感等不適，故使用前需測量血壓',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '類固醇',
        },
        {
          t: '肌肉注射',
        },
        {
          t: '促進胎兒肺部成熟。',
        },
        {
          t: '體液電解質不平衡(鈉滯留、鉀流失)、體重增加、水腫。',
        },
        {
          t: '',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: 'Ritodrine (Yutopar)',
        },
        {
          t: '靜脈注射',
          rowspan: 4,
        },
        {
          t: '可使子宮鬆弛、預防早產。',
        },
        {
          t: '剛注射時可能會有心跳加速、出汗、呼吸喘、噁心、嘔吐等不適症狀。',
        },
        {
          t: '可將床頭抬高減輕不適。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '硫酸鎂MgSO4(Magnesium Sulfate)',
        },
        {
          t: ['輔助平滑肌鬆弛，可降低血壓、減少子宮收縮頻率。', '懷孕32週前使用，可降低新生兒腦性麻痺發生機率。'],
        },
        {
          t: '口乾、全身發熱、面潮紅、噁心、嘔吐、呼吸不順。因藥物刺激性高靜脈注射部位及血管偶會有疼痛感。',
        },
        {
          t: '小便量會減少，須記錄小便量及進食量以便評估輸入、輸出量是否平衡。若感到肌肉無力、想睡覺或呼吸困難須隨時通知醫護人員。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: 'Tractocile(Atosiban)',
        },
        {
          t: ['預防早產。', '於健保安胎藥物出現嚴重副作用時可考慮採用。'],
        },
        {
          t: '輕微的心跳加速、噁心、嘔吐、頭痛、眩暈、低血壓。',
        },
        {
          t: '此藥為自費安胎藥物，費用昂貴。可使用於有心血管病史、糖尿病史及代謝性疾病的產婦。',
        },
      ],
    },
  ],
};

//
export const trackingMemberContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 60,
    },
    {
      id: uuid(),
      width: 150,
    },
  ],
  head: [
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '區域',
        },
        {
          t: '參與醫院',
        },
        {
          t: '小兒科醫師',
        },
        {
          t: '個案管理師',
        },
        {
          t: '聯絡電話',
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),

      texts: [
        {
          t: '北一區',
          rowspan: 6,
        },
        {
          t: '臺大醫院',
        },
        {
          t: '鄒國英、曹伯年、周弘傑、陳倩儀、顏玎安、黃信中',
        },
        {
          t: '劉芸秀',
          rowspan: 4,
        },
        {
          t: ['0975-209-694'],
          rowspan: 4,
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '婦幼醫院',
        },
        {
          t: '方麗容、王培瑋、鄭彥辰、柯申',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '國泰醫院',
        },
        {
          t: '洪依利、沈仲敏、謝武勳',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '永和耕莘醫院',
        },
        {
          t: '林明弘',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '北醫附醫',
        },
        {
          t: '蘇一宇',
        },
        {
          t: '李慧樁',
        },
        {
          t: '02-27372181 #8533',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '亞東醫院',
        },
        {
          t: '梁翔、李佳容、郭子敏、王詩欣',
        },
        {
          t: ['沈依玟', '曾昱菁'],
        },
        {
          t: ['02-89667000 #4451', '2747'],
        },
      ],
    },

    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '北二區',
          rowspan: 4,
        },
        {
          t: '新光醫院',
        },
        {
          t: '穆淑琪、林姃慧、陳怡伶、蔡立儀',
        },
        {
          t: '黎育伶',
          rowspan: 4,
        },
        {
          t: ['02-28332211 #2590', '02-28378347'],
          rowspan: 4,
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '臺北榮總',
        },
        {
          t: '鄭玫枝、李昱聲、曹珮真、陳威宇、周佳穗',
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '台北長庚醫院',
        },
        {
          t: '翁逸豪、程劭文',
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '三軍總醫院',
        },
        {
          t: '謝國祥',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '北三區',
          rowspan: 2,
        },
        {
          t: '台北馬偕醫院',
        },
        {
          t: '許瓊心、張瑞幸、林佳瑩、張弘洋、陳佳慧、詹偉添',
        },
        {
          t: '陳淑貞',
        },
        {
          t: '02-25433535 #3266',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '新竹市立馬偕兒童醫院',
        },
        {
          t: '宋聿翔、劉子瑜、陳政偉、柯信如',
        },
        {
          t: '林采燕',
        },
        {
          t: '03-5719999 #6609',
        },
      ],
    },

    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '北四區',
        },
        {
          t: '林口長庚醫院',
        },
        {
          t: '林瑞瑩、朱世明、徐任甫、傅仁煇、江明洲、楊長佑、許凱翔、李建忠、賴美吟、吳怡萱',
        },
        {
          t: '余慕嫻',
        },
        {
          t: '0978-103-153',
        },
      ],
    },

    {
      id: uuid(),

      texts: [
        {
          t: '中一區',
          rowspan: 2,
        },
        {
          t: '中國附醫',
        },
        {
          t: '林鴻志、邱曉郁、林湘瑜、蔡明倫、陳映廷、鄭皓文、沈上博、楊曉涵',
        },
        {
          t: '梅麗菁',
          rowspan: 2,
        },
        {
          t: '04-22052121 #11462.#11463',
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '中山附醫',
        },

        {
          t: '陳善銘、李英齊、王杏安',
        },
      ],
    },

    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '中二區',
          rowspan: 2,
        },
        {
          t: '臺中榮總',
        },
        {
          t: '林明志、王德明、許雅淇、徐仲庭、林怡瑄',
        },
        {
          t: '陳珮妤',
          rowspan: 2,
        },
        {
          t: '04-23592525 #5994',
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '彰化基督教醫院',
        },
        {
          t: '蕭建洲、陳曉能、李政翰、陳家玉、陳俐如',
        },
      ],
    },

    {
      id: uuid(),

      texts: [
        {
          t: '台南區',
          rowspan: 5,
        },
        {
          t: '成大醫院',
        },
        {
          t: '黃朝慶、林毓志、杜伊芳、林永傑、陳俐文、余文豪、陳妍如',
        },
        {
          t: '劉子毓',
          rowspan: 4,
        },
        {
          t: ['06-2353535 #7141', '0911-728-917'],
          rowspan: 4,
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '奇美醫院',
        },
        {
          t: '王藍浣、王麟玉、蔡文暉',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '新樓醫院',
        },
        {
          t: '陳奕吟',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '郭綜合醫院',
        },
        {
          t: '林愛惜',
        },
      ],
    },
    {
      id: uuid(),

      texts: [
        {
          t: '嘉義基督教醫院',
        },
        {
          t: '黃琳淇、吳宗祐、王姿婷',
        },
        {
          t: '蕭乃嘉',
        },
        {
          t: '05-2765041 #5882',
        },
      ],
    },

    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '高雄區',
          rowspan: 4,
        },
        {
          t: '高雄榮總',
        },
        {
          t: '王曉萍、張振宗、楊智絜',
        },
        {
          t: '沈純潔',
          rowspan: 3,
        },
        {
          t: ['07-7317123 #8111', '07-7333266'],
          rowspan: 3,
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '高雄長庚',
        },
        {
          t: '陳志誠、鍾美勇、黃新純、陳豐順、歐陽美珍、張心瑜、陳宜綸',
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '高醫附設中和醫院',
        },
        {
          t: '陳秀玲、鐘浩瑋、楊書婷、蘇品淳、蔡偉哲',
        },
      ],
    },
    {
      id: uuid(),
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
      texts: [
        {
          t: '義大醫院',
        },
        {
          t: '楊詠寗、吳建儀、吳佩玲、劉賢冠',
        },
        {
          t: '紀淯馨',
        },
        {
          t: ['07-6150011 #257381', '0975-106-270'],
        },
      ],
    },

    // {
    //   id: uuid(),
    //   texts: [
    //     {
    //       t: '花東區',
    //     },
    //     {
    //       t: '台東馬偕',
    //     },
    //     {
    //       t: '沈上博',
    //     },
    //     {
    //       t: '吳家慧',
    //     },
    //     {
    //       t: '089-310150 #5994',
    //     },
    //   ],
    // },
  ],
};

export const trackingNationalServiceContent = {
  colGroup: [
    {
      id: uuid(),
      width: 70,
    },
    {
      id: uuid(),
      width: 130,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 70,
    },
    {
      id: uuid(),
      width: 80,
    },
    {
      id: uuid(),
      width: 150,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '區域', rowspan: 2 },
        { t: '參與醫院', rowspan: 2 },
        { t: '服務狀況', colspan: 3 },
        { t: '小兒科醫師', rowspan: 2 },
        { t: '聯絡人', rowspan: 2 },
        { t: '連絡電話', rowspan: 2 },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '醫院主動安排門診追蹤' }, { t: '家屬自行掛號返診' }, { t: '轉介它院' }],
    },

    {
      id: uuid(),

      texts: [
        {
          t: '北部(20)',
          rowspan: 20,
        },
        { t: '陽大附醫' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '宋亭璇' },
        { t: '當班護理師' },
        { t: '03-9325192 #15011' },
      ],
    },
    {
      id: uuid(),

      texts: [

        { t: '羅東博愛醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '吳淑娟' },
        { t: '江鈺婷個管師' },
        { t: '039-543131 #3275' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '羅東聖母醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '─' },
        { t: '當班護理師' },
        { t: '03-9544106 #7761~3' },
      ],
    },

    {
      id: uuid(),

      texts: [

        { t: '基隆長庚醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '廖穗綾' },
        { t: '當班護理師' },
        { t: '02-24313131 #2605' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '部立基隆醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '謝王虎' },
        { t: '陳郁如個管師' },
        { t: '02-24292525 #7597' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '淡水馬偕醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '曾愷悌' },
        { t: '林育年個管師' },
        { t: '02-28094661 #3681' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '汐止國泰醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '李淑婷' },
        { t: '當班護理師' },
        { t: '02-26482121 #2631~2' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '臺安醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '王和順' },
        { t: '宋欣茹個管師' },
        { t: '02-27718151 #2764  ' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '市立仁愛醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '柯婷蓉' },
        { t: '柯婷蓉醫師' },
        { t: '02 27093600 #3449' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '宏恩醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '何驊' },
        { t: '張允嫻個管師' },
        { t: '02-27713161 #300' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '部立雙和醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '陳瑛芳' },
        { t: '李洧緁個管師' },
        { t: '02-22490088 #2957' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '新店耕莘醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '翁麗緻' },
        { t: '當班護理師' },
        { t: '02-22193391 #15520' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '萬芳醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '黃亮迪' },
        { t: '江梅君個管師' },
        { t: '02-29307930 #8106' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '台北慈濟醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '趙露露' },
        { t: '呂淑如個管師' },
        { t: '02-66289779 #2290' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '恩主公醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '許登欽' },
        { t: '當班護理師' },
        { t: '02-26723456 #6951' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '輔大附醫' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '簡佑軒' },
        { t: '當班護理師' },
        { t: '02-85128888 #28865' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '土城醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '許時耘' },
        { t: '當班護理師' },
        { t: '02-22630588 #3187' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '國軍桃園醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '張君丞' },
        { t: '當班護理師' },
        { t: '03-4799595 #327011' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '東元醫院醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '王昱程' },
        { t: '當班護理師' },
        { t: '03-5527000 #1250' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '新竹臺大醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '陳麒年' },
        { t: '黃安琪個管師' },
        { t: '03-5326151 #522312' },
      ],
    },

    {
      id: uuid(),
      texts: [
        { t: '中部(13)', rowspan: 13 },
        { t: '大甲光田醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '劉佑全' },
        { t: '當班護理師' },
        { t: '04-26885599 #5530' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '沙鹿光田醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '周宇光' },
        { t: '當班護理師' },
        { t: '04-26625111 #2254' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '部立豐原醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '馬志豪' },
        { t: '吳嘉玲個管師' },
        { t: '04-25271180 #2246' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台中慈濟醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '黃冠翰' },
        { t: '當班護理師' },
        { t: '04-36060666 #4609' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '中港澄清醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '黃元韻' },
        { t: '當班護理師' },
        { t: '04-24632000 #32781~2' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '部立臺中醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '李德敏' },
        { t: '當班護理師' },
        { t: '04-22294411 #2674' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '林新醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '陳信利' },
        { t: '當班護理師' },
        { t: '04-22586688 #6699' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '童綜合醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '李春銘' },
        { t: '楊馨捷個管師' },
        { t: '04-26581919 #51030' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '彰濱秀傳醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '張佑全' },
        { t: '林碧惠個管師' },
        { t: '04-7813888 #72196' },
      ],
    },

    {
      id: uuid(),
      texts: [
        { t: '彰化秀傳醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '詹秀玉' },
        { t: '當班護理師' },
        { t: '04-7256166 #82396' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '南投佑民醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '李柏勳' },
        { t: '當班護理師' },
        { t: '049-2358151 #2500' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '虎尾若瑟醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '黃文欽' },
        { t: '許芷菱個管師' },
        { t: '05-6337333 #2238' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '雲林臺大醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '蔡政憲' },
        { t: '林靜娟個管師' },
        { t: '05-5323911 #563408' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '南部(5)', rowspan: 5 },
        { t: '大林慈濟醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '陳聖達' },
        { t: '陳聖達醫師' },
        { t: '05-2648000 #1551' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '嘉義長庚醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '蘇崇豪' },
        { t: '當班護理師' },
        { t: '05-3621000 #3136' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '聖馬爾定醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '江美治' },
        { t: '黃麗蓉護理長' },
        { t: '05-2756000 #4503,4507' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '國軍高雄醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '簡任宏' },
        { t: '吳媛婷個管師' },
        { t: '07-5817121 #2380' },
      ],
    },
    {
      id: uuid(),

      texts: [
        { t: '屏東基督教醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: '卓德松' },
        { t: '林孟華個管師' },
        { t: ['08-7368686 #3412', '0928-071-610'] },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '東部(4)', rowspan: 4 },
        { t: '花蓮慈濟醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '張宇勳' },
        { t: '廖玉琪個管師' },
        { t: '03-8561825 #14872' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '花蓮門諾醫院' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '鄭永隆' },
        { t: '劉曉玲個管師' },
        { t: '03-8241436' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台東馬偕醫院' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '' },
        { t: '' },
        { t: ['張恩菩', '魏佑慈'] },
        { t: '賴玉真個管師' },
        { t: '089-310150 #274' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台東基督教醫院' },
        { t: '' },
        { t: '' },
        { t: 'V', style: { 'text-align': 'center' } },
        { t: '鄭弋' },
        { t: '當班護理師' },
        { t: '089-960888 #1545' },
      ],
    },
  ],
};

export const understandPregnantContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [{ t: '' }, { t: '外觀' }, { t: '顏色' }, { t: '氣味' }, { t: '流量' }],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [{ t: '破水' }, { t: '清澈' }, { t: '透明、淡黃色' }, { t: '無異味' }, { t: '持續流出' }],
    },
    {
      id: uuid(),
      texts: [{ t: '漏尿' }, { t: '清澈' }, { t: '黃色' }, { t: '尿液味' }, { t: '會停止' }],
    },
    {
      id: uuid(),
      texts: [{ t: '分泌物' }, { t: '黏稠' }, { t: '乳白色' }, { t: '無異味' }, { t: '-' }],
    },
  ],
};

export const milkPowerPrescriptionContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [{ t: '體重(公斤)' }, { t: '每3小時餵奶者' }, { t: '每4小時餵奶者' }],
    },
  ],
  body: [
    { id: uuid(), texts: [{ t: 2 }, { t: '45~65 cc' }, { t: '60~90 cc' }] },
    { id: uuid(), texts: [{ t: 2.5 }, { t: '55~70 cc' }, { t: '75~90 cc' }] },
    { id: uuid(), texts: [{ t: 3 }, { t: '65~85 cc' }, { t: '90~110 cc' }] },
    { id: uuid(), texts: [{ t: 3.5 }, { t: '75~95 cc' }, { t: '100~130 cc' }] },
    { id: uuid(), texts: [{ t: 4 }, { t: '90~110 cc' }, { t: '120~150 cc' }] },
    { id: uuid(), texts: [{ t: 4.5 }, { t: '95~120 cc' }, { t: '130~165 cc' }] },
    { id: uuid(), texts: [{ t: 5 }, { t: '105~130 cc' }, { t: '150~185 cc' }] },
    { id: uuid(), texts: [{ t: 6 }, { t: '120~140 cc' }, { t: '180~220 cc' }] },
  ],
};

export const breastMilkExpireContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '冰存溫度儲存型態', style: textCenter },
        { t: '剛擠出來的奶水', style: textCenter },
        { t: '在冷藏室內解凍的奶水', style: textCenter },
        { t: '在冰箱之外以溫水解凍的奶水', style: textCenter },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '室溫25度以下', style: textCenter },
        { t: [styleText('6~8小時', textCenter), boldText('(早產兒3小時)', textCenter)] },
        { t: '2~4小時', style: textCenter },
        { t: '當餐使用', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '冷藏室(0-4度)', style: textCenter },
        { t: [styleText('5~8天(早產兒2天)', textCenter), boldText('(早產兒3天)', textCenter)], style: textCenter },
        { t: '24小時', style: textCenter },
        { t: '4小時', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '獨立冷凍室', style: textCenter },
        { t: '3個月', style: textCenter },
        { t: '不可再冷凍', style: textCenter },
        { t: '不可再冷凍', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '-20度以下冷凍庫', style: textCenter },
        { t: '6~12個月', style: textCenter },
        { t: '不可再冷凍', style: textCenter },
        { t: '不可再冷凍', style: textCenter },
      ],
    },
  ],
};

export const milkPowerFeatureContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '配方奶種類', style: textCenter },
        { t: '成分特色', style: textCenter },
        { t: '適用對象', style: textCenter },
      ],
    },
  ],
  body: [
    { id: uuid(), texts: [{ t: '6個月以下之新生兒', style: textCenter }, { t: '' }, { t: '2~4小時', style: textCenter }] },
    {
      id: uuid(),
      texts: [
        { t: '成長奶粉', style: textCenter },
        { t: '營養含量較嬰兒配方奶粉高，蛋白質含量亦提高' },
        { t: '6個月以上開始添加副食品之幼兒', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '早產兒配方奶粉', style: textCenter },
        {
          t: ['1.乳糖改為葡萄糖聚合物', '2.中鏈脂肪酸油取代部分長鏈脂肪酸油', '3.容易消化吸收、卡路里高（多20%）'],
        },
        { t: '早產兒', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '特殊配方奶粉(需經醫師、營養師指示才可食用)', style: textCenter },
        { t: '不含乳糖、部分水解、完全水解、元素水解…' },
        { t: '不同狀況之嬰幼兒', style: textCenter },
      ],
    },
  ],
};

export const subFoodMixinMethodContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 300,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [{ t: '配方奶種類' }, { t: '建議添加次數' }, { t: '' }],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '4-6個月' },
        { t: '1天1次' },
        { t: '為學習適應食物及嚐鮮。滿六個月後可給富含醣及鐵質的食物如地瓜泥。' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '7-9個月' },
        { t: '1天2次' },
        {
          t: '可配合寶寶喜愛抓取物品的特性，將食物製作成易於拿取的形狀，但是要避免硬而圓的食物，以免造成異物吸入。添加蛋白質來源的食物如肉泥。增加五榖根莖類來源的食物。八個月可開始嘗試魚肉泥。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '10-12個月' },
        { t: '1天3次' },
        {
          t: '寶寶開始長下門牙後可嘗試改成乾飯，食物型態可漸漸改成固體，並且開始讓寶寶學習用器具吃飯，建立良好飲食習慣。',
        },
      ],
    },
  ],
};

export const bodyTemperatureAdjustContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '溫度', style: textCenter },
        { t: '所需衣服', style: textCenter },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '27度以上', style: textCenter },
        { t: '一件上衣加上尿褲即可', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '24-27度', style: textCenter },
        { t: '一件上衣加上一件薄外套', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '22-24度', style: textCenter },
        { t: '一件紗布衣、一件棉衣，再加上一件長的外袍', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '22度以下', style: textCenter },
        { t: '除了上三件外，再加一件毛毯及一頂帽子', style: textCenter },
      ],
    },
  ],
};

export const takeBodyTemperatureContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [{ t: '' }, { t: '額溫' }, { t: '耳溫' }, { t: '口溫' }, { t: '腋溫' }, { t: '肛溫' }],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [{ t: '發燒標準' }, { t: '≧37.5℃' }, { t: '≧38℃' }, { t: '≧37.5℃' }, { t: '≧37.2-37.5℃' }, { t: '≧38℃' }],
    },

    {
      id: uuid(),
      texts: [
        { t: '測量時間' },
        {
          t: '依據不同廠牌電子體溫計，通常機器自動偵測後發出提示聲，就可以判讀。若為水銀體溫計可用於口腔、腋下及肛門做測量約3-5分鐘左右。',
          colspan: 5,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '測量方式',
          colspan: 6,
          style: {
            textAlign: 'center',
          },
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '耳溫' },
        {
          t: ['將耳朵向下向後拉，再將耳溫槍測溫頭放入耳內'],
          colspan: 5,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '口溫' },
        {
          t: ['將體溫計(片)置於舌下含住即可、不可用力咬住及說話。'],
          colspan: 5,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '肛溫' },
        {
          t: ['以凡士林或潤滑油潤滑體肛表，插入肛門1.25-2.5公分，以手固定肛表測量。'],
          colspan: 5,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '注意事項' },
        {
          t: [
            {
              renderText: textInRow([
                {
                  t: '1.',
                },
                {
                  t: '額溫',
                  style: {
                    textDecoration: 'underline',
                  },
                },
                {
                  t: '槍較無年齡限制，但受外在因素影響，準確度較差。',
                },
              ]),
            },
            {
              renderText: textInRow([
                {
                  t: '2. 1-3個月以下或體重很低的新生兒，優先考慮量',
                },
                {
                  t: '腋溫',
                  style: {
                    textDecoration: 'underline',
                  },
                },
                {
                  t: '，3個月以上之新生兒可以使用肛溫、腋溫電子體溫計及耳溫槍。',
                },
              ]),
            },
            {
              renderText: textInRow([
                {
                  t: '3. 5歲以下的孩子',
                },
                {
                  t: '禁止',
                  style: {
                    textDecoration: 'underline',
                  },
                },
                {
                  t: '採',
                },
                {
                  t: '口溫',
                  style: {
                    textDecoration: 'underline',
                  },
                },
                {
                  t: '測量，以免誤食。',
                },
              ]),
            },
          ],
          colspan: 5,
        },
      ],
    },
  ],
};

export const babyHeatToHospitalContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '身體狀況評估', style: textCenter },
        { t: '症狀', style: textCenter },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '溫度', style: textCenter },
        { t: '溫度超過40℃', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '意識', style: textCenter },
        { t: '昏睡、難以喚醒、躁動不安、意識不清', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '頭頸部', style: textCenter },
        { t: '頭部或頸部疼痛或頸部僵硬', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '肢體', style: textCenter },
        { t: '痙攣(手腳抽搐)', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '呼吸', style: textCenter },
        { t: '呼吸困難、呼吸急促或緩慢、臉部蒼白或發紫', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '皮膚', style: textCenter },
        { t: '發燒併發皮膚斑點或紅疹', style: textCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '腸胃', style: textCenter },
        { t: '嚴重腹脹、劇烈腹痛或腹瀉、嘔吐不止、血便', style: textCenter },
      ],
    },
  ],
};

export const babyGrowContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },

    {
      id: uuid(),
      width: 300,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '矯正年齡' },
        { t: '粗動作' },
        { t: '精細動作' },
        { t: '語言及認知' },
        { t: '身邊處理及社會性' },
        { t: '建議的活動與玩具' },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '足月-滿1個月' },
        { t: ['仰躺時，四肢能呈現屈曲。', '俯臥時，臉不能抬離床面。'] },
        { t: '眼睛能隨移動目標轉90度。' },
        { t: '能自動發出聲音，但非哭聲。' },
        { t: '注意別人的臉。' },
        {
          t: [
            '建議的活動',
            '放在爬行毯或塑膠墊上，協助俯臥以游泳姿勢來運動各個肢體。',
            '協助側翻或翻身。',
            '協助並支撐他坐好，讓他學會平衡身體。',
            '抱住他成站姿讓他有跳的動作。',
            '洗澡、換尿布時多撫摸孩子或在水盆裡玩水。',
            '對孩子唱歌說話或播放音樂。',
            '建議的玩具',
            '音樂鈴、音樂聆聽、顏色鮮明的擠壓玩具(如紅、黃、藍)、手搖鈴、柔軟布製玩具、爬行毯',
          ],
          rowspan: 3,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '滿2-3個月' },
        {
          t: ['拉扶坐起，只有輕微的頭部落後。', '趴著時，可以將頭抬起至45度。'],
        },
        { t: '手會自動張開。' },
        { t: '手會自動張開。' },
        { t: '逗他會微笑。' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '滿4-5個月' },
        {
          t: ['抱直時，頸部可以保持頭部豎直。', '俯臥時，會用兩隻前臂將頭抬高至90度。', '會自己翻身(俯臥成仰臥)。'],
        },
        { t: ['常舉手凝視手部。', '雙手互握在一起。', '手能伸向物品。'] },
        { t: ['高興的尖叫。', '哭鬧時，會因為照顧者的撫聲而停止。'] },
        { t: ['雙眼可凝視人物，追尋移動物體。', '會對照顧者親切露出微笑。'] },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '滿6-8個月' },
        { t: ['不須扶持，可以坐穩。', '獨立自己爬。', '坐時會移動身體，挪向所要的物體。'] },
        { t: ['自己會拉開臉上的小方巾或手帕。', '將東西由一手換到另一手。', '會用兩手拿小杯子。'] },
        { t: ['看他時，他會回看你。', '轉向聲源。', '發出上無意義的單詞「ㄅㄚ」、「ㄇㄚ」、「ㄉㄚ」'] },
        { t: ['會用張口或用動作表示要吃。', '自己能拿餅乾吃。'] },
        {
          t: [
            '建議的活動',
            '對著寶寶叫他的名字或簡單的音。',
            '叫他如何拍手或用手取物敲擊發出咚咚響聲。',
            '扮有趣滑稽的表情鼓勵孩子模仿。',
            '玩躲貓貓。',
            '給他球推著玩或丟球。',
            '將玩具放遠讓他自己去拿。',
            '抱著他坐下或站起來並說出這個行為意義如「坐下」。',
            '指出身體部位並說出名稱。',
            '展示大圖片學習看圖識物。',
            '建議的玩具',
            '固齒器、手搖鈴、勤、積木或大球、玩具電話或小火車。',
            '簡單可拆的玩具或娃娃。',
            '可以促進手指運動的按壓模型盒、柔軟布製玩具。',
            '不同大小一套的盒子或杯子(類似俄羅斯娃娃)。',
          ],
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '滿9-11個月' },
        {
          t: ['拉著物體自己站起來。', '雙手拉著會移幾步。'],
        },
        {
          t: ['自己會抓住東西往嘴巴送。', '會拍手。'],
        },
        { t: '會揮手表示再見。' },
        {
          t: ['會怕陌生人。', '叫他的名字或小名他會有反應。'],
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        { t: '滿12-18個月' },
        {
          t: ['雙手扶著家俱會走幾步。', '走得很穩。', '可以走很快。', '牽著他或扶著欄杆可以走上樓梯。'],
        },
        {
          t: ['會用拇指和食指捏起小的物體。', '會把小物體放入杯子。', '會用筆亂塗。', '會開瓶蓋。'],
        },
        {
          t: ['有意義的叫爸爸、媽媽。', '會跟著或主動說出一個單字。'],
        },
        {
          t: ['會脫帽子。', '會雙手端著杯子喝水。', '幫他穿衣服會自己伸出胳臂或腿。'],
        },
        {
          t: [
            '建議的活動',
            '看圖說故事。',
            '童謠哼唱。',
            '照鏡子遊戲。',
            '敲打樂器。',
            '堆積木。',
            '拍手遊戲。',
            '躲貓貓。',
            '投擲活動。',
            '公園活動散步。',
            '球的遊戲。',
            '學習使用餐具。',
            '撿拾玩具做整理。',
            '拼圖。',
            '紙筆塗鴉。',
            '騎木馬。',
            '追趕跑跳全身運動',
            '建議的玩具',
            '球類、簡單厚板故事書、童謠音樂、嵌洞積木、簡單識字卡或識圖卡、鏡子、娃娃或抱枕、食具、敲打玩具、組合玩具、套套杯、串珠子或大衣扣、穿線洞板、簡單拼圖(5-10片)、紙筆塗鴉。',
          ],
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '滿18-24個月',
        },
        {
          t: ['會自己由椅子上爬下。', '會單腳踢球，一腳站穩另一腳踢。', '會手心朝下丟球或東西。'],
        },
        {
          t: ['會一頁一頁的翻書。', '會將水倒入另一個杯子。'],
        },
        {
          t: ['能正確地指出身體的一個部位。', '能正確地說出身體6個部位的名稱。'],
        },
        {
          t: '會自己脫衣服。',
        },
      ],
    },
  ],
};

export const vaccinationContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 300,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [{ t: '對象' }, { t: '適合開始接種年齡' }, { t: '疫苗種類' }, { t: '劑數' }],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: ['早產兒', '(≤ 32妊娠週)'],
        },
        { t: '出院前3-5天' },
        { t: '呼吸融合細胞病毒單株抗體' },
        { t: '連續6個月' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '妊娠週數35週以下且併有慢性肺疾病之早產兒' },
        { t: '出院前3-5天' },
        { t: '呼吸融合細胞病毒單株抗體' },
        { t: '連續6個月' },
      ],
    },

    {
      id: uuid(),
      texts: [{ t: '新生兒' }, { t: '出生24小時內' }, { t: 'B型肝炎免疫球蛋白(母親為B肝帶原者)' }, { t: '1劑' }],
    },

    {
      id: uuid(),
      texts: [{ t: '早產兒' }, { t: '出生24小時內' }, { t: 'B型肝炎疫苗(母親為B肝帶原者)' }, { t: '第0劑' }],
    },

    {
      id: uuid(),
      texts: [{ t: '新生兒' }, { t: '體重滿2000公克' }, { t: 'B型肝炎疫苗' }, { t: '第1劑' }],
    },

    {
      id: uuid(),
      texts: [{ t: '新生兒' }, { t: '出生滿1個月' }, { t: 'B型肝炎疫苗' }, { t: '第2劑' }],
    },
    {
      id: uuid(),
      texts: [
        { t: '嬰幼兒', rowspan: 2 },
        { t: '出生滿2個月', rowspan: 2 },
        { t: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗' },
        { t: '第1劑' },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '13價結合型肺炎鏈球菌疫苗' }, { t: '第1劑' }],
    },

    {
      id: uuid(),
      texts: [
        { t: '嬰幼兒', rowspan: 2 },
        { t: '出生滿4個月', rowspan: 2 },
        { t: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗' },
        { t: '第2劑' },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '13價結合型肺炎鏈球菌疫苗' }, { t: '第2劑' }],
    },
    {
      id: uuid(),
      texts: [
        { t: '嬰幼兒' },
        {
          t: ['出生滿5個月', '(建議5-8個月)'],
        },
        { t: '卡介苗' },
        { t: '1劑' },
      ],
    },

    {
      id: uuid(),
      texts: [
        { t: '嬰幼兒', rowspan: 2 },
        { t: '出生滿6個月', rowspan: 2 },
        { t: 'B型肝炎疫苗' },
        { t: '第3劑', rowspan: 2 },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗' }],
    },

    {
      id: uuid(),
      texts: [{ t: '嬰幼兒', rowspan: 2 }, { t: '出生滿12個月', rowspan: 2 }, { t: '水痘疫苗' }, { t: '1劑' }],
    },
    {
      id: uuid(),
      texts: [{ t: '麻疹、腮腺炎、德國麻疹混合疫苗' }, { t: '第1劑' }],
    },

    {
      id: uuid(),
      texts: [
        { t: '嬰幼兒', rowspan: 2 },
        { t: '出生滿12-15個月', rowspan: 2 },
        { t: '13價結合型肺炎鏈球菌疫苗' },
        { t: '第3劑' },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: 'A型肝炎疫苗' }, { t: '第1劑' }],
    },

    {
      id: uuid(),
      texts: [{ t: '嬰幼兒' }, { t: '出生滿1年3個月' }, { t: '日本腦炎疫苗' }, { t: '第1劑' }],
    },

    {
      id: uuid(),
      texts: [
        { t: '嬰幼兒' },
        { t: '出生滿1年6個月' },
        { t: '白喉破傷風非細胞性百日咳、b型嗜血桿菌及不活化小兒麻痺五合一疫苗' },
        { t: '第4劑' },
      ],
    },

    {
      id: uuid(),
      texts: [{ t: '嬰幼兒' }, { t: '出生滿1年6-9個月' }, { t: 'A型肝炎疫苗(與第一劑至少間隔6個月)' }, { t: '第2劑' }],
    },
    {
      id: uuid(),
      texts: [{ t: '嬰幼兒' }, { t: '出生滿2年3個月' }, { t: '日本腦炎疫苗(與第一劑至少間隔12個月)' }, { t: '第2劑' }],
    },

    {
      id: uuid(),
      texts: [
        { t: '學齡兒童', rowspan: 4 },
        { t: '出生滿2年3個月', rowspan: 3 },
        { t: '減量破傷風白喉非細胞性百日咳及不活化小兒麻痺混合疫苗' },
        { t: '1劑' },
      ],
    },

    {
      id: uuid(),
      texts: [{ t: '麻疹、腮腺炎、德國麻疹混合疫苗' }, { t: '第2劑' }],
    },
    {
      id: uuid(),
      texts: [{ t: '日本腦炎疫苗(提供已完成接種3劑不活化疫苗之幼童接種)' }, { t: '第3劑' }],
    },
    {
      id: uuid(),
      texts: [{ t: '國小一年級' }, { t: '卡介苗疤痕普查(無種紀錄且測驗陰性者補種)' }, { t: '' }],
    },
  ],
};

export const preemieTrackingCheckAndEarlyCareContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },

    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '執行單位' },
        { t: '目的' },
        { t: '對象' },
        { t: '方式' },
        { t: '開始時間' },
        { t: '評估項目' },
        { t: '評量結果' },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        { t: '早產兒基金會追蹤檢查工作（與醫院合作）' },
        { t: '早期發現及時轉介及早療育' },
        { t: '出生體重≤1500公克或出生週數≤29週（不分程度）' },
        { t: '主動篩檢' },
        {
          t: ['矯正年齡 6M 開始6.12.24M定期追蹤（部分執行 5Y 追蹤）'],
        },
        {
          t: ['生長評估', '・心理衡鑑（智能）', '・神經動作發展感官功能（視、聽力）'],
        },
        {
          t: ['BSID-Ⅲ 轉介標準：', '・認知 < 90', '語言於兩歲時仍有疑慮者', '・動作 ≤ 90 並參考臨床評估表現'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '早期療育評估' },
        { t: '提供發展遲緩個案必要之早期治療安置...等照護' },
        { t: '有發展遲緩之兒童' },
        { t: '被動就診' },
        { t: '無固定起始點（通常家屬發現是2歲以後）' },
        { t: ['・心理衡鑑', '・職能物理', '・社工家庭評估'] },
        { t: '依院內小兒科神經科、復健科、心智科、耳鼻喉科...評量結果進行療育' },
      ],
    },
  ],
};

export const highRiskGroupsContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 300,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '生活行為',
          style: textCenter,
          tdStyle: {
            verticalAlign: 'middle',
          },
        },
        {
          t: [
            '◎營養狀況不良',
            boldText('◎抽菸、喝酒'),
            '◎使用成癮藥物',
            '◎工作過度勞累',
            '◎衛生習慣不良',
            '◎情緒焦躁不安',
            '◎貧血…等',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '孕前行為',
          style: textCenter,
          tdStyle: {
            verticalAlign: 'middle',
          },
        },
        {
          t: [
            boldText('◎懷孕年齡小於18歲或大於40歲。'),
            '◎未婚懷孕。',
            '◎懷孕間隔太密。',
            '◎曾發生過早產、早發陣痛或妊娠早期-中期流產。',
            '◎曾患腎盂腎炎。',
            '◎前胎有子宮閉鎖不全之現象。',
            '◎曾有不良的產科病史。',
            '◎子宮接受過手術(如子宮頸椎狀切除、人工流產...等)。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '懷孕期間',
          style: textCenter,
          tdStyle: {
            verticalAlign: 'middle',
          },
        },
        {
          t: [
            renderBoldText('感染', '◎孕期', '、發燒。'),
            '◎妊娠高血壓、子癲前症、子癲症。',
            '◎妊娠糖尿病 ',
            '◎雙胞胎或多胞胎。',
            boldText('◎前置胎盤。'),
            boldText('◎胎盤早期剝離。'),
            boldText('◎胎盤功能不佳'),
            '◎早期破水。',
            '◎羊水過多或過少。',
            '◎子宮畸型。',
            '◎子宮內胎兒生長遲緩 ',
            renderBoldText('腹部急症', '◎腹部手術、', '(盲腸炎或是卵巢扭轉、腹膜炎)。'),
            '◎產前曾出血。',
            '◎身體或情緒方面的創傷。',
            '◎胎兒染色體異常或先天性畸型(如食道閉鎖不全)。',
            '◎孕期體重超過80公斤或小於40公斤。',
            '◎胎兒過大',
          ],
        },
      ],
    },
  ],
};

export const preventContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 300,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '醫院',
        },
        {
          t: '衛教護理師',
        },
        {
          t: '諮詢電話',
        },
        {
          t: '服務時間',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '馬偕醫院',
        },
        {
          t: '張淑雲',
        },
        {
          t: '02-25433535#2076~2078',
        },
        {
          t: ['週一至週五8:00am~4:00pm', '週六、日及其他時間仍有護理人員接電話'],
          rowspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '聖保祿醫院' }, { t: '王怡惠' }, { t: '03-3613141#7285、7286' }],
    },
    {
      id: uuid(),
      texts: [
        { t: '新竹馬偕' },
        { t: '鍾嘉純' },
        { t: '03-6119595#2508、2521' },
        { t: ['週一至週五8:00am~5:00pm', '週六、日及其他時間仍有護理人員接電話'], rowspan: 2 },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '中國醫藥大學附設醫院' }, { t: '劉淑女' }, { t: '04-22052121#3990' }],
    },
    {
      id: uuid(),
      texts: [
        { t: '中山醫學大學附設醫院' },
        { t: '黃美鳳' },
        { t: '04-24739595#20701' },
        { t: ['週一至週五8:00am~4:00pm', '週六、日及其他時間仍有護理人員接電話'], rowspan: 1 },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '彰化基督教醫院' },
        { t: '劉瑩娟' },
        { t: '04-7238595#3490' },
        { t: ['週一至週五8:00 am -5:30 pm 週六8:00 am -12:00 am其他時間仍有護理人員接電話'] },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '奇美醫院' }, { t: '陳佳婉' }, { t: '06-2812811#55400、55401' }, { t: ['週一至週五8:00 am -4:00 pm週六、日及其他時間仍有護理人員接電話'], rowspan: 2 }],
    },
    {
      id: uuid(),
      texts: [{ t: '新樓醫院' }, { t: '徐秋玉' }, { t: '06-2748316#4255' }],
    },
    {
      id: uuid(),
      texts: [
        { t: '成大醫院' },
        { t: '陳娟涓' },
        { t: '06-2353535#2333' },
        { t: ['週一至週五8:00am~5:00pm', '週六、日及其他時間請撥06-2353535 #2861'] },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '屏東基督教醫院' }, { t: '楊婉芬' }, { t: '08-7368686#4421、4420' }, { t: ['週一至週五8:00 am -4:00 pm週六、日及其他時間仍有護理人員接電話'], rowspan: 2 }],
    },
    {
      id: uuid(),
      texts: [{ t: '門諾醫院' }, { t: '陳立蓁' }, { t: '03-8241392' }],
    },
  ],
};

export const domesticTraingingContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 300,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        { t: '年度' },
        {
          t: '場次日期',
        },
        {
          t: '內容',
        },
        {
          t: '合辦醫院',
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '92',
          rowspan: 2,
        },
        {
          t: '11.07',
        },
        {
          t: [
            '一、研習會簡介',
            '二、早產兒個案管理模式介紹',
            '三、台灣之早產嬰、幼兒現況分析',
            '四、早產兒身心發展評估與預後',
            '五、早產父母之人格特質及身心壓力調適',
            '六、早產兒居家照顧需求與居家護理',
            '七、早產兒的個案管理',
          ],
        },
        {
          t: '台北馬偕紀念醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.28',
        },
        {
          t: [
            '一、研習會簡介',
            '二、台灣之早產嬰、幼兒現況分析',
            '三、早產兒身心發展評估與預後',
            '四、早產兒家庭需求與居家護理',
            '五、早產父母之人格特質及身心壓力調適',
            '六、早產兒的個案管理',
          ],
        },
        {
          t: '中國醫藥大學附設醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '93',
          rowspan: 2,
        },
        {
          t: '09.06',
        },
        {
          t: [
            '一、台灣早產兒之現況分析',
            '二、早產兒身心發展評估與預後',
            '三、早產兒居家照護需求',
            '四、早產兒出院計畫及居家照護',
            '五、早產兒個案管理及收案模式',
          ],
        },
        {
          t: '高雄榮民總醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '09.10',
        },
        {
          t: [
            '一、台灣早產兒之現況分析',
            '二、早產兒身心發展評估與預後',
            '三、早產兒居家照護',
            '四、早產兒出院計畫及個案管理',
            '五、早產兒居家照護個案追蹤模式',
          ],
        },
        {
          t: '馬偕紀念醫院台東分院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '94',
        },
        {
          t: '10.21',
        },
        {
          t: [
            '一、新移民婦女健康需求與早產現況',
            '二、預防早產-早產兒防治專案與現況',
            '三、台灣之早產嬰、幼兒現況分析',
            '四、早產救護先驅-談早產兒醫療訓練中心',
            '五、早產兒發展評估-早產兒追蹤檢查',
            '六、早產兒居家照護需求',
            '七、早產兒健康照護網-早產兒個案管理',
            '八、早產兒個案管理經驗分享',
          ],
        },
        {
          t: '中國醫藥大學附設醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '95',
          rowspan: 2,
        },
        {
          t: '10.20',
        },
        {
          t: [
            '一、早產嬰幼兒現況分析',
            '二、早產兒健康照護網--早產防治與安胎示範病房',
            '三、早產兒身心發展評估與預後',
            '四、早產兒健康照護網--居家訪視補助方案',
            '五、早產兒健康照護網--94年度個案管理模式及成果呈現',
            '六、早產兒健康照護網—早產兒居家照護需求',
          ],
        },
        {
          t: '高雄榮民總醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '10.27',
        },
        {
          t: [
            '一、早產嬰幼兒現況分析',
            '二、早產兒健康照護網--早產防治與安胎示範病房',
            '三、早產兒身心發展評估與預後',
            '四、早產兒健康照護網--居家訪視補助方案',
            '五、早產兒健康照護網--94年度個案管理模式及成果呈現',
            '六、早產兒健康照護網--早產兒居家訪視經驗分享',
          ],
        },
        {
          t: '花蓮門諾醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '96',
          rowspan: 3,
        },
        {
          t: '09.14',
        },
        {
          t: [
            '一、早產兒現況分析',
            '二、早產兒餵食工具之選擇',
            '三、早產兒餵食互動方案之介紹',
            '四、日本醫療訪問研習分享',
            '五、早產兒身心發展評估與預後 ',
            '六、早產兒健康照護網—早產防治與安胎示範病房',
          ],
        },
        {
          t: '國立成功大學醫學院附設醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '10.04',
        },
        {
          t: [
            '一、台灣早產兒醫療現況',
            '二、日本醫療訪問研習分享',
            '三、早產兒身心發展評估與預後',
            '四、早產兒家庭調適歷程',
            '五、非藥物性措施—於早產兒疼痛處理之應用',
            '六、早產兒個案社會資源應用',
          ],
        },
        {
          t: '台北馬偕紀念醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '10.11',
        },
        {
          t: [
            '一、早產兒醫療現況',
            '二、健康促進—新生兒加護中心之角色',
            '三、早產兒健康照護網—早產防治與安胎示範病房',
            '四、日本醫療訪問研習分享',
            '五、早產兒健康照護網—居家訪視經驗分享',
            '六、早產兒個案社會資源應用',
          ],
        },
        {
          t: '台中榮民總醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '98',
          rowspan: 2,
        },
        {
          t: '11.06',
        },
        {
          t: [
            '一、早產兒現況分析',
            '二、早產兒照護之訪美研習分享—醫師組',
            '三、早產兒照護之訪美研習分享—護理組',
            '四、極低出生體重早產兒神經發展預後與評估',
            '五、安胎病房中安胎產婦之心理需求',
            '六、早產兒家庭出院準備服務',
          ],
        },
        {
          t: '高雄榮民總醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.21',
        },
        {
          t: [
            '一、早產兒照護之訪美研習分享—醫師組',
            '二、0-3歲兒童發展篩檢 ',
            '三、早產兒照護之訪美研習分享—護理組',
            '四、NIDCAP---新生兒個別化發展性照護 ',
            '五、台灣原住民孕婦早產相關原因分析',
            '六、安胎病房中安胎產婦之心理需求',
          ],
        },
        {
          t: '馬偕紀念醫院台東分院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '104',
          rowspan: 4,
        },
        {
          t: '05.08',
        },
        {
          t: [
            '一、孕期健康與高危險妊娠',
            '二、神經發展異常早產兒之辨識及早期介入之原則',
            '三、台灣早產兒現況分析',
            '四、早產兒家庭調適歷程',
            '五、早產兒居家照護需求及家訪常見問題',
            '六、早產兒社會資源應用',
          ],
        },
        {
          t: ['臺中市政府衛生局', '中國醫藥大學兒童醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '06.04',
        },
        {
          t: [
            '一、認識高危險妊娠及早產防治',
            '二、台灣早產兒醫療照護現況分析',
            '三、早產兒發展評估及早期療育',
            '四、在早產兒的需要上看到社會責任~認識早產暨早產兒服務方案 ',
            '五、早產兒居家照護需求及常見問題 ',
            '六、早產兒家庭調適及社會資源應用',
          ],
        },
        {
          t: ['臺北市政府衛生局', '台北馬偕紀念醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '08.13',
        },
        {
          t: [
            '一、孕期健康與高危險妊娠',
            '二、台灣早產兒醫療照護現況分析',
            '三、早產兒發展評估及早期療育',
            '四、早產兒家庭調適歷程',
            '五、早產兒居家照護需求及常見問題',
            '六、早產兒居家訪視常見問題及經驗分享',
            '七、早產兒社會資源應用',
          ],
        },
        {
          t: ['桃園市政府衛生局', '林口長庚紀念醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '09.15',
        },
        {
          t: [
            '一、高危險妊娠婦女之孕產期照護',
            '二、特殊早產兒出院後的醫療照顧',
            '三、早產兒發展評估及早期療育',
            '四、早產兒家庭的挑戰與調適',
            '五、早產兒出院準備與居家照護 ',
            '六、早產兒家庭之社會資源應用',
          ],
        },
        {
          t: ['臺南市政府衛生局', '國立成功大學醫學院附設醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '105',
          rowspan: 3,
        },
        {
          t: '07.19',
        },
        {
          t: [
            '一、早產兒常見疾病評估及處置 ',
            '二、早產兒發展評估及早期療育',
            '三、新生兒安寧緩和照護及悲傷輔導 ',
            '四、早產兒經口餵食困難與照護',
            '五、早產兒居家照護需求及常見問題',
          ],
        },
        {
          t: '高雄榮民總醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '08.03',
        },
        {
          t: [
            '一、早產兒營養議題',
            '二、早產兒經口餵食困難與照護',
            '三、營養及餵食的無縫照護~從早產兒出院準備到出院後續的照護',
            '四、早產兒管路照護之經驗分享',
            '五、早產兒照護之法律與倫理',
          ],
        },
        {
          t: '新光吳火獅紀念醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '09.30',
        },
        {
          t: [
            '一、早產兒常見疾病評估及處置',
            '二、新生兒發展性照護措施於臨床之應用',
            '三、早產兒居家照護需求及常見問題',
            '四、復健師於住院早產兒之角色與功能',
            '五、創新用物於早產兒之應用-以發展性照護理念為基石',
            '六、早產兒發展評估及早期療育',
          ],
        },
        {
          t: '臺中榮民總醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '106',
          rowspan: 3,
        },
        {
          t: '11.02',
        },
        {
          t: [
            '一、認識早產兒與早產兒異常徵象觀察處理及生長發育評估',
            '二、早產嬰幼兒之營養與副食品添加',
            '三、早產兒居家照護技巧與常見問題',
            '四、早產兒社會資源的應用',
          ],
        },
        {
          t: ['臺北市衛生局', '台北馬偕紀念醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.13',
        },
        {
          t: [
            '一、認識早產兒與早產兒異常徵象觀察處理及生長發育評估',
            '二、早產嬰幼兒之營養與副食品添加',
            '三、早產兒居家照護技巧與常見問題',
            '四、早產兒社會資源的應用',
          ],
        },
        {
          t: ['臺南市政府衛生局', '奇美醫療財團法人奇美醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.30',
        },
        {
          t: [
            '一、早產兒居家照護技巧與常見問題',
            '二、早產兒社會資源的應用',
            '三、早產嬰幼兒常見營養問題與腸胃道疾病',
            '四、認識早產兒與早產兒異常徵象觀察處理及生長發育評估',
          ],
        },
        {
          t: ['臺中市政府衛生局', '中國醫藥大學附設醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '107',
          rowspan: 4,
        },
        {
          t: '11.01',
        },
        {
          t: [
            '一、電子版早產兒照顧手冊及醫護人員早產兒照護線上數位教材說明及宣導',
            '二、台灣早產兒醫療照護與追蹤現況',
            '三、日本神奈川的早產兒照護~醫師組',
            '四、日本神奈川的早產兒照護~護理組',
          ],
        },
        {
          t: ['新生兒科醫學會', '台北馬偕紀念醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.10',
        },
        {
          t: [
            '一、電子版早產兒照顧手冊及醫護人員早產兒照護線上數位教材說明及宣導',
            '二、台灣早產兒醫療照護與追蹤現況',
            '三、日本神奈川的早產兒照護~醫師組',
            '四、日本神奈川的早產兒照護~護理組',
          ],
        },
        {
          t: ['新生兒科醫學會', '臺南市政府衛生局', '國立成功大學醫學院附設醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.14',
        },
        {
          t: [
            '一、電子版早產兒照顧手冊及醫護人員早產兒照護線上數位教材說明及宣導',
            '二、台灣早產兒醫療照護與追蹤現況',
            '三、日本神奈川的早產兒照護~醫師組',
            '四、日本神奈川的早產兒照護~護理組',
          ],
        },
        {
          t: ['新生兒科醫學會', '臺東縣政府衛生局', '台東馬偕紀念醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '11.30',
        },
        {
          t: [
            '一、電子版早產兒照顧手冊及醫護人員早產兒照護線上數位教材說明及宣導',
            '二、台灣早產兒醫療照護與追蹤現況',
            '三、日本神奈川的早產兒照護~醫師組',
            '四、日本神奈川的早產兒照護~護理組',
          ],
        },
        {
          t: ['新生兒科醫學會', '臺中市政府衛生局', '中國醫藥大學兒童醫院'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '108',
          rowspan: 4,
        },
        {
          t: '07.04',
        },
        {
          t: ['一、以早產兒視角-談早期療護與復健議題', '二、以早產兒視角-新生兒重症友善照護議題'],
        },
        {
          t: '臺北醫學大學附設醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '08.02',
        },
        {
          t: ['一、幼兒心理發展概述及照顧與早產兒家族手足支持', '二、高醫早產兒支持團體之設立及運作'],
        },
        {
          t: '高雄醫學大學附設中和紀念醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '09.20',
        },
        {
          t: ['一、早產兒營養支持與壞死性腸炎', '二、東區早產兒照護經驗分享(花蓮慈濟醫院、花蓮門諾醫院)'],
        },
        {
          t: '花蓮慈濟醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '10.03',
        },
        {
          t: ['一、早產兒0-18歲生長發育面面觀', '二、早產兒的早期發展與介入'],
        },
        {
          t: '中山醫學大學附設醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '109',
          rowspan: 4,
        },
        {
          t: '08.05',
        },
        {
          t: [
            '一、教人學習謙卑高度的早產新生兒照護',
            '二、新生兒缺血缺氧性腦病變低溫治療文獻回顧及經驗分享',
            '三、守護高危險性新生兒-週產期轉診救護',
            '四、早產的預防',
            '五、從生產事故事件通報談建立風險控管',
            '六、凶險性胎盤的孕產準備及精準處理',
          ],
        },
        {
          t: '新光吳火獅紀念醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '09.11',
        },
        {
          t: [
            '一、最初的音樂饗宴-早產兒與音樂',
            '二、Gastrointestinal emergency in the newborn infants',
            '三、高危險妊娠',
            '四、新生兒發展性照護',
          ],
        },
        {
          t: '澄清醫院中港分院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '09.17',
        },
        {
          t: [
            '一、常見遺傳疾病診斷檢查及諮詢',
            '二、高危險妊娠超音波診斷',
            '三、人工生殖與高危險妊娠',
            '四、在生命的起點，承受等量的希望與絕望~陪伴早產兒父母面對未知的焦慮',
            '五、奇美經驗分享',
            '六、早產兒營養照護與分享',
          ],
        },
        {
          t: '奇美醫療財團法人奇美醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '10.14',
        },
        {
          t: [
            '一、高危險妊娠與早產',
            '二、新生兒加護病房之復健介入',
            '三、婦幼個管師業務分享',
            '四、早產兒個管師業務分享',
          ],
        },
        {
          t: '花蓮門諾醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '110',
        },
        {
          t: '11.14',
        },
        {
          t: [
            '一、早產兒基金會 30 週年回顧與前瞻',
            '二、極低出生體重早產兒追蹤專案 25 週年回顧與前瞻',
            '三、台灣極低出生體重早產兒的周產期與住院期間相關罹病率於兩個時期的比較',
            '四、台灣極低出生體重早產兒的神經學發展-二十年之變化',
            '五、非常早期出生早產兒童在學齢前的神經行為及神經認知表現',
            '六、極低出生體重早產兒出院後的醫療需求：談 1997-2017年間居家氧氣療法、兩歲時醫療與復健及早療的需求',
            '七、分享日本在宅兒童醫療經驗與其未來政策',
          ],
        },
        {
          t: '台北馬偕紀念醫院',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '111',
        },
        {
          t: '疫情影響停辦一年',
          colspan: 3,
          style: {
            textAlign: 'center',
          },
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '112',
          rowspan: 4,
        },
        {
          t: '9.8',
        },
        {
          t: [
            '一、淺談孕期營養與胎兒、嬰兒健康及世代疫病發生的關係',
            '二、胎兒生產的產前照護',
            '三、Breast milk and preterm health',
            '四、早產兒的早期物理治療介入指引',
            '五、新生兒發展性照護與滋養照護，你我的角色',
          ],
        },
        {
          t: [
            '中國醫藥大學兒童醫院',
            '中國醫藥大學附設醫院',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '9.14',
        },
        {
          t: [
            '一、子癲前症孕產婦照護',
            '二、認識早產兒的營養需求以及照顧策略',
            '三、早產兒吞嚥治療介入及早產兒的物理治療介入',
            '四、台東馬偕早產兒出院準備及居家照護作業現況',
          ],
        },
        {
          t: [
            '台東馬偕紀念醫院',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '9.22',
        },
        {
          t: [
            '一、孕婦早產身心靈照護',
            '二、小於胎齡兒及早產兒的長期併發症',
            '三、運用支持照護陪伴早產家庭走進生活',
            '四、早產新生兒的餵食促進及感官調控原則 及早產兒的新生兒期與嬰兒期之動作發展及運動要點',
            '五、音樂治療在周產期及早產兒照護之應用',
            '六、水療在兒童物理治療的應用及經驗分享',
          ],
        },
        {
          t: [
            '臺北醫學大學附設醫院',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '10.19',
        },
        {
          t: [
            '一、高危險妊娠風險控管',
            '二、早產兒呼吸窘迫症候群照護',
            '三、承受生命的喜與痛-早產兒父母關懷',
            '四、早產寶寶的發展守護',
            '五、陪伴長大-談早產兒的出院照顧',
          ],
        },
        {
          t: [
            '高雄長庚紀念醫院',
          ],
        },
      ],
    },
    // 113
    {
      id: uuid(),
      texts: [
        {
          t: '113',
          rowspan: 4,
        },
        {
          t: '8.23',
        },
        {
          t: [
            '一、減低早產兒ROP檢查重度疼痛率之實務分享',
            '二、產後媽媽的韌性增強',
            '三、AI語音技術在產兒照護的應用與前景',
            '四、周產期轉診',
            '五、產兒科護理人員之注意義務',
          ],
        },
        {
          t: [
            '台北馬偕紀念醫院',
            '馬偕兒童醫院',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '8.29',
        },
        {
          t: [
            '一、周產期轉診',
            '二、協助家長應對孩子的手術-醫護可以怎麼做？',
            '三、產後媽媽的韌性增強',
            '四、產兒科護理人員之注意義務',
          ],
        },
        {
          t: [
            '花蓮慈濟醫院',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '9.4',
        },
        {
          t: [
            '一、周產期轉診',
            '二、產後媽媽的韌性增強',
            '三、AI語音技術在產兒照護的應用與前景',
            '四、兒科的困難決定',
            '五、產兒科護理人員之注意義務',
          ],
        },
        {
          t: [
            '彰化基督教醫院',
            '彰化基督教兒童醫院',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '9.10',
        },
        {
          t: [
            '一、周產期轉診',
            '二、兒科的困難決定',
            '三、產後媽媽的韌性增強',
            '四、產兒科護理人員之注意義務',
            '五、AI語音技術在產兒照護的應用與前景',
          ],
        },
        {
          t: [
            '台南新樓醫院',
          ],
        },
      ],
    },
  ],
};

export const foreignTrainingContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 300,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 120,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '編號',
        },
        {
          t: '年度',
        },
        {
          t: '國家',
        },
        {
          t: '參訪機構',
        },
        {
          t: '人數',
        },
        {
          t: '學習報導',
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '1',
        },
        {
          t: ['1993.08.22-29', '(8天)'],
        },
        {
          t: '日本',
        },
        {
          t: ['1.鹿兒島市立病院', '2.大阪府立母子保健總合醫院', '3.都立大塚病院', '4.東京女子醫科大學病院'],
        },
        {
          t: '32',
        },
        {
          t: '無',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '2',
        },
        {
          t: ['1995.09.20-29', '(10天)'],
        },
        {
          t: '澳洲',
        },
        {
          t: [
            '1. 布里斯本 Mater Misericordiae Mothers’ Hospital',
            '2. 墨爾本 Monash Medical centre',
            "3. 墨爾本 Royal Women's Hospital",
            '4. 坎培拉 Woden Valley Hospital',
            '5. 雪梨 Westmead Hospital',
          ],
        },
        {
          t: '30',
        },
        {
          t: '無',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '3',
        },
        {
          t: ['1999.09.08-17', '(10天)'],
        },
        {
          t: '美.加',
        },
        {
          t: [
            '1. Surrey Healthiest Babies Possible',
            '2. Vancouver Healthiest Babies Possible',
            "3. Children's Foundation",
            "4. Women's Hospital",
            '5. University of Washington Academic Medical Center',
          ],
        },
        {
          t: '34',
        },
        {
          t: '無',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '4',
        },
        {
          t: ['2003.09.02-13', '(12天)'],
        },
        {
          t: ['英國', '法國', '德國', '荷蘭'],
        },
        {
          t: [
            '1.St. Mary’s Hospital',
            '2.PARK ROYAL MORIETTE HOSPITAL',
            '3.JEANNE DE FLANDRE HOSPITAL',
            '4.NICU IN COLOGNE KINDERKLINIK KOELN',
            '5.University Medical Center Rotterdam, Sophia Children’sHospital',
          ],
        },
        {
          t: '27',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
          rowspan: 3,
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '5',
        },
        {
          t: ['2006.09.10-14', '(5天)'],
        },
        {
          t: '日本',
        },
        {
          t: ['1.大阪府立母子保健總合醫院', '2.東京女子醫科大學病院', '3.國立成育醫病中心'],
        },
        {
          t: '36',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '6',
        },
        {
          t: ['2009.09.04-13', '(10天)'],
        },
        {
          t: '美東',
        },
        {
          t: [
            '1. Saint Barnabas Medical Center',
            '2. New York-Presbyterian Morgan Stanly Children’s Hospital',
            '3. Women & Infants Hospital of Rhode Island',
            '4. Brigham and Women’s Hospital',
          ],
        },
        {
          t: '34',
        },
      ],
    },
  ],
};

export const foreignTrainingShortTermContent = {
  colGroup: [
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 300,
    },
    {
      id: uuid(),
      width: 50,
    },
    {
      id: uuid(),
      width: 120,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '編號',
        },
        {
          t: '年度',
        },
        {
          t: '國家',
        },
        {
          t: '參訪機構',
        },
        {
          t: '人數',
        },
        {
          t: '學習報導',
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '7',
        },
        {
          t: '1994',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          t: '無',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '8',
        },
        {
          t: '1995',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          t: '無',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '9',
        },
        {
          t: '1996',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '8',
        },
        {
          t: '無',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '10',
        },
        {
          t: '1997',
        },
        {
          t: '澳洲',
        },
        {
          t: '布里斯本 Mater Misericordiae Mothers’ Hospital',
        },
        {
          t: '10',
        },
        {
          t: '無',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '11',
        },
        {
          t: '1998',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          t: '無',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '12',
        },
        {
          t: '2000',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '8',
        },
        {
          t: '無',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '12',
        },
        {
          t: '2000',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          t: '無',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '13',
        },
        {
          t: '2003',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '5',
        },
        {
          t: '無',
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          t: '14',
        },
        {
          t: '2005',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '15',
        },
        {
          t: '2007',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '16',
        },
        {
          t: '2010',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '3',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '17',
        },
        {
          t: '2012',
        },
        {
          t: '日本',
        },
        {
          t: '大阪府立母子保健總和醫院',
        },
        {
          t: '6',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '18',
        },
        {
          t: '2014',
        },
        {
          t: '日本',
        },
        {
          t: '神奈川縣立兒童醫療中心',
        },
        {
          t: '7',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '19',
        },
        {
          t: '2016',
        },
        {
          t: '日本',
        },
        {
          t: '神奈川縣立兒童醫療中心',
        },
        {
          t: '6',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '20',
        },
        {
          t: '2018',
        },
        {
          t: '日本',
        },
        {
          t: '神奈川縣立兒童醫療中心',
        },
        {
          t: '8',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '21',
        },
        {
          t: '2024',
        },
        {
          t: '日本',
        },
        {
          t: '神奈川縣立兒童醫療中心',
        },
        {
          t: '7',
        },
        {
          render: h(OpenItem, {
            label: '表單/文件下載',
            link: {
              name: 'form-download',
            },
            type: 'internal',
          }),
        },
      ],
    },
  ],
};

export const SocialWorkerContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 150,
    },

    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 150,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '醫院名稱',
          style: {
            'font-weight': '700',
            textAlign: 'center',
          },
        },
        {
          t: '部門',
          style: {
            'font-weight': '700',
            textAlign: 'center',
          },
        },
        {
          t: '負責社工師',
          style: {
            'font-weight': '700',
            textAlign: 'center',
          },
        },
        {
          t: '連絡電話',
          style: {
            'font-weight': '700',
            textAlign: 'center',
          },
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [{ t: '北部合約醫院', colspan: 4, style: { 'text-align': 'center' } }],
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
    },
    {
      id: uuid(),
      texts: [
        { t: '台大醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '蔡孟茹', style: { textAlign: 'center' } },
        { t: '02-23123456 #270431' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '婦幼醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '林佩璇', style: { textAlign: 'center' } },
        { t: '02-23889595 #2024' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台北馬偕醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '賴美合', style: { textAlign: 'center' } },
        { t: '02-25433535 #3052' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '淡水馬偕醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '林珊如', style: { textAlign: 'center' } },
        { t: '02-28094661 #2214, 2215' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台安醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '蘇秋雲', style: { textAlign: 'center' } },
        { t: '02-27718151 #2841' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '國泰醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '郭玫怡', style: { textAlign: 'center' } },
        { t: '02-27082121 #1905' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '北醫附醫', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '蔡宜嬙', style: { textAlign: 'center' } },
        { t: '02-27372181 #5162' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '新光醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '吳安妮', style: { textAlign: 'center' } },
        { t: '02-28332211 #2581' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '臺北榮民總醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '王琇鋒', style: { textAlign: 'center' } },
        { t: '02-28757318' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '三軍總醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '蔡惠芳', style: { textAlign: 'center' } },
        { t: '02-87923311 #16573' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '萬芳醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '羅苡勻', style: { textAlign: 'center' } },
        { t: '02-29307930 #1831' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '亞東醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '陳品傑', style: { textAlign: 'center' } },
        { t: '02-77281701' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台北慈濟醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '楊惠儀', style: { textAlign: 'center' } },
        { t: '02-66289779 #5501' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '耕莘醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '高偉琴', style: { textAlign: 'center' } },
        { t: '02-22193391 #66102' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '永和耕莘醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '翁廷萱', style: { textAlign: 'center' } },
        { t: '02-29286060 #10655' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '雙和醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '張菡容', style: { textAlign: 'center' } },
        { t: '02-22490088 #2409' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '恩主公醫院', style: { textAlign: 'center' } },
        { t: '社工課', style: { textAlign: 'center' } },
        { t: '詹佳蓉', style: { textAlign: 'center' } },
        { t: '02-26723456 #1157' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '基隆長庚醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '高玉玲', style: { textAlign: 'center' } },
        { t: '02-24313131 #3088' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '林口長庚醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '朱怜穎', style: { textAlign: 'center' } },
        { t: '03-3281200 #5128' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台北長庚醫院', style: { textAlign: 'center' } },
        { t: '社服組', style: { textAlign: 'center' } },
        { t: '劉千瑜', style: { textAlign: 'center' } },
        { t: '02-27135211 #3620' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '土城醫院', style: { textAlign: 'center' } },
        { t: '社工課', style: { textAlign: 'center' } },
        { t: '邱瑀庭', style: { textAlign: 'center' } },
        { t: '02-22630588 #6910' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '衛福部桃園醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '蔡易珍', style: { textAlign: 'center' } },
        { t: '03-3699721 #1606' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '聖保祿醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '陳小吟', style: { textAlign: 'center' } },
        { t: '03-3613141 #3316' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '新竹市立馬偕兒童醫院', style: { textAlign: 'center' } },
        { t: '社服組', style: { textAlign: 'center' } },
        { t: '張靖伶', style: { textAlign: 'center' } },
        { t: '03-5719999 #2104' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '新竹台大醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '陳思雅', style: { textAlign: 'center' } },
        { t: '03-5326151 #526002' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '東元醫院', style: { textAlign: 'center' } },
        { t: '社服組', style: { textAlign: 'center' } },
        { t: '郭秀惠', style: { textAlign: 'center' } },
        { t: '03-5527000 #1366' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '大千醫院', style: { textAlign: 'center' } },
        { t: '社工課', style: { textAlign: 'center' } },
        { t: '葉佳玲', style: { textAlign: 'center' } },
        { t: '037-357125 #43105' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '陽明附醫', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '陳怡君', style: { textAlign: 'center' } },
        { t: '039-325192 #10965' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '羅東博愛醫院', style: { textAlign: 'center' } },
        { t: '社工課', style: { textAlign: 'center' } },
        { t: '吳宇涵', style: { textAlign: 'center' } },
        { t: '03-9543131 #1084' },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '中部合約醫院', colspan: 4, style: { 'text-align': 'center' } }],
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
    },
    {
      id: uuid(),
      texts: [
        { t: '中山附醫', style: { textAlign: 'center' } },
        { t: '社服組', style: { textAlign: 'center' } },
        { t: '蔡旻潔', style: { textAlign: 'center' } },
        { t: '04-24739595 #38365' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '中國附醫', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '蕭伊珊', style: { textAlign: 'center' } },
        { t: '04-22052121 #11420' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '臺中榮民總醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '張凱筑', style: { textAlign: 'center' } },
        { t: '04-23592525 #2945' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '澄清醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '黃秀萍', style: { textAlign: 'center' } },
        { t: '04-24632000 #55265' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '光田醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '楊雅婷', style: { textAlign: 'center' } },
        { t: '04-26625111 #2153' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '童綜合醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '邱奕瑄', style: { textAlign: 'center' } },
        { t: '04-26581919 #4847' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '彰化基督教醫院', style: { textAlign: 'center' } },
        { t: '社工部', style: { textAlign: 'center' } },
        { t: '江慧真', style: { textAlign: 'center' } },
        { t: '04-7238595 #4555' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '秀傳醫院', style: { textAlign: 'center' } },
        { t: '社工課', style: { textAlign: 'center' } },
        { t: '江姵諠', style: { textAlign: 'center' } },
        { t: '04-7256166 #85775' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '臺大雲林分院', style: { textAlign: 'center' } },
        { t: '社工組', style: { textAlign: 'center' } },
        { t: '陳妍妙', style: { textAlign: 'center' } },
        { t: '05-5323911 #560502  ' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '若瑟醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '吳麗卿', style: { textAlign: 'center' } },
        { t: '05-6337333 #8174' },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '南部合約醫院', style: { textAlign: 'center' }, colspan: 4 }],
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
    },
    {
      id: uuid(),
      texts: [
        { t: '嘉義基督教醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '陳淑惠', style: { textAlign: 'center' } },
        { t: '05-2765041 #7172' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '聖馬爾定醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '鍾欣儒', style: { textAlign: 'center' } },
        { t: '05-2756000 #1852' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '嘉義長庚醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '戴巧雯', style: { textAlign: 'center' } },
        { t: '05-3621000 #2175' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '大林慈濟醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '鄭伊真', style: { textAlign: 'center' } },
        { t: '05-2648000 #5039' },
      ],
    },

    {
      id: uuid(),
      texts: [
        { t: '郭綜合醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '葉倬澔', style: { textAlign: 'center' } },
        { t: '06-2221111 #1139' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '新樓醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '林依姍', style: { textAlign: 'center' } },
        { t: '06-2748316 #2033' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '成大醫院', style: { textAlign: 'center' } },
        { t: '社工部', style: { textAlign: 'center' } },
        { t: '郭玟雅', style: { textAlign: 'center' } },
        { t: '06-2353535 #4975' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '奇美醫院', style: { textAlign: 'center' } },
        { t: '社服部', style: { textAlign: 'center' } },
        { t: '陳宜婷', style: { textAlign: 'center' } },
        { t: '06-2812811 #52123' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '柳營奇美醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '陳怡伶', style: { textAlign: 'center' } },
        { t: '06-6226999#72588' },
      ],
    },
    // {
    //   id: uuid(),
    //   texts: [
    //     { t: '聖功醫院', style: { textAlign: 'center' } },
    //     { t: '社服室', style: { textAlign: 'center' } },
    //     { t: '馮捷昇', style: { textAlign: 'center' } },
    //     { t: '07-2238153 #2110' },
    //   ],
    // },
    {
      id: uuid(),
      texts: [
        { t: '高醫附醫', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '呂昌翰', style: { textAlign: 'center' } },
        { t: '07-3121101 #5251, 5254' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '聖功醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '李宛融', style: { textAlign: 'center' } },
        { t: '07-2238153 #2230' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '高雄榮民總醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '許文娟', style: { textAlign: 'center' } },
        { t: '07-3422121 #77008' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '義大醫院', style: { textAlign: 'center' } },
        { t: '社工課', style: { textAlign: 'center' } },
        { t: '黃姵慈', style: { textAlign: 'center' } },
        { t: '07-6150011 #1339' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '高雄長庚醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '沈迦蜜', style: { textAlign: 'center' } },
        { t: '07-7317123 #8134' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '屏東基督教醫院', style: { textAlign: 'center' } },
        { t: '社工室', style: { textAlign: 'center' } },
        { t: '謝忻樺', style: { textAlign: 'center' } },
        { t: '08-7368686 #2414' },
      ],
    },
    {
      id: uuid(),
      texts: [{ t: '東部合約醫院', style: { textAlign: 'center' }, colspan: 4 }],
      style: { 'background-color': 'rgba(255, 195, 180, 0.2)' },
    },
    {
      id: uuid(),
      texts: [
        { t: '花蓮慈濟醫院', style: { textAlign: 'center' } },
        { t: '社服室', style: { textAlign: 'center' } },
        { t: '蘇倚萱', style: { textAlign: 'center' } },
        { t: '038-561825 #13251' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '台東馬偕醫院', style: { textAlign: 'center' } },
        { t: '社服組', style: { textAlign: 'center' } },
        { t: '李宜頻', style: { textAlign: 'center' } },
        { t: '089-310150 #373' },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '花蓮門諾醫院', style: { textAlign: 'center' } },
        { t: '社服課', style: { textAlign: 'center' } },
        { t: '陳思蒨', style: { textAlign: 'center' } },
        { t: '038-241202' },
      ],
    },
  ],
};

export const intracerebralHemorrhageSymdronesContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 150,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'typical-symptoms',
            label: '典型症狀',
            mt: false,
            inline: true,
            center: true,
          }),
        },
        {
          render: h(HomeCareImg, {
            type: 'atypical-symptoms',
            label: '非典型症狀',
            mt: false,
            inline: true,
            center: true,
          }),
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: [
            '1.原本穩定生理現象卻突然變差',
            '2.出現呼吸暫停',
            '3.運動異常、角弓反張',
            '4.抽搐',
            '5.前囟門緊且膨出',
            '6.血球容積下降、血壓降低和酸血症',
          ],
        },
        {
          t: [
            '1.意識程度變差',
            '2.木僵和焦躁不安',
            '3.呼吸不規則',
            '4.體溫不穩',
            '5.自發動作減少、肌肉張力降低或增加等',
            '以上表現可時好時壞，持續幾天，也可能惡化變成水腦。',
          ],
        },
      ],
    },
  ],
};

export const babySleepDemainingContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 150,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '年齡',
          style: textCenter,
        },
        {
          t: '夜間睡眠',
          style: textCenter,
        },
        {
          t: '日間睡眠',
          style: textCenter,
        },
        {
          t: '總睡眠',
          style: textCenter,
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '一個月大',
          style: textCenter,
        },
        {
          t: '8.5小時',
          style: textCenter,
        },
        {
          t: '7小時',
          style: textCenter,
        },
        {
          t: '15.5小時',
          style: textCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '三個月大',
          style: textCenter,
        },
        {
          t: '10小時',
          style: textCenter,
        },
        {
          t: '5小時',
          style: textCenter,
        },
        {
          t: '15小時',
          style: textCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '一歲大',
          style: textCenter,
        },
        {
          t: '11.25小時',
          style: textCenter,
        },
        {
          t: '2.5小時',
          style: textCenter,
        },
        {
          t: '13.75小時',
          style: textCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '三歲大',
          style: textCenter,
        },
        {
          t: '10.5小時',
          style: textCenter,
        },
        {
          t: '1.5小時',
          style: textCenter,
        },
        {
          t: '12小時',
          style: textCenter,
        },
      ],
    },
  ],
};

export const cerebralPalsyContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 350,
    },
  ],
  head: [
    {
      id: uuid(),
      texts: [
        {
          t: '類型',
        },
        {
          t: '症狀表現',
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '痙攣型',
        },
        {
          t: [
            '1.大腦皮質損傷',
            '2.肌肉張力高。',
            '3.體型較弱小。',
            '4.上肢常呈彎曲，下肢呈內收、半彎曲、內旋之剪刀式及踮腳尖型態、肢體僵硬或緊縮。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '手足徐動型',
        },
        {
          t: [
            '1.腦幹基底核損傷',
            '2.肌肉張力不穩且會改變。',
            '3.體型較瘦。',
            '4.早期通常是軟趴型，2-3歲時會發展出不自主動作。',
            '5.四肢或臉部會有一些不自主的跳動或緩慢的扭動。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '協調不良型',
        },
        {
          t: ['1.小腦損傷、平衡功能較差。', '2.肌肉張力不穩且不斷的在改變。', '3.手眼協調動作差'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '軟癱型',
        },
        {
          t: ['1.肌肉張力低', '2.頭、頸部軟弱無力', '3.動作緩慢無力', '4.平衡反應很差'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          render: h('p', [
            h(
              'span',
              {
                style: {
                  ...font(),
                },
              },
              '資料來源：',
            ),
            h(
              'a',
              {
                href: 'https://www.cplink.org.tw/whats_cp.php',
                target: '_blank',
                rel: 'noreferrer noopener',
                style: {
                  ...font(),
                  'text-decoration': 'underline',
                  cursor: 'pointer',
                },
              },
              '中華民國腦性麻痺協會',
            ),
          ]),
          colspan: 2,
        },
      ],
    },
  ],
};

export const openDuctusArteriosusTreatContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 400,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'vaccination-pre-vaccination-assessment',
            label: '藥物治療',
            mt: false,
            mb: false,
            center: true,
          }),
        },
        {
          t: '臨床上在給予藥物來關閉動脈導管前，需先確認有無出血傾向或腎功能狀況方可使用，通常給予Indomethacin、ibuprofen、ACT治療，目前藥物有口服及針劑劑型兩種(自費)。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'treat',
            label: '心導管治療',
            mt: false,
            mb: false,
            center: true,
          }),
        },
        {
          t: '在X光機的放射線導引下，從鼠蹊部的血管(股動脈或是股靜脈)，將封阻器放置到開放性動脈導管中完成關閉的效果。但因其器材與嬰幼兒血管大小的限制，會視體重足夠時再執行，雖曾有1000公克以下的早產兒接受心導管治療，但仍缺乏長期追蹤報告，目前美國建議接受此治療方式的新生兒體重為2500公克以上。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'surgery',
            label: '手術治療',
            mt: false,
            mb: false,
            center: true,
          }),
        },
        {
          t: '手術方法由左後側開胸一個5公分左右的切口，進行動脈導管綁紮手術，以達斷絕其血流的效果。手術傷口面積較心導管術大，會留下疤痕。但發生合併症機率較低，可能有傷口感染、喉返神經麻痺（recurrent laryngeal nerve palsy）或是乳糜胸情形。在還沒有足夠的臨床證據證實心導管的長期效果之前，外科手術治療仍會是首選。',
        },
      ],
    },
  ],
};

export const bookStartReadingContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 350,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '歷史',
        },
        {
          t: [
            '1992年從英國伯明罕開始推廣讓幼兒提早開始養成閱讀習慣的活動，後來推展至歐洲各國、日本、韓國、泰國、台灣、澳洲等地。台灣是由信誼基金會與地方政府及各鄉鎮圖書館合作，致力推廣於全國。教育部於2009年也開始推行此活動進入國民小學， 2014年更名為「國民中小學新生閱讀推廣計畫」，國中小新生可獲得一份閱讀禮袋。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '目的',
        },
        {
          t: ['讓嬰幼兒從出生後就能開始接觸多元的圖書本，在閱讀中促進不同能力的發展，並養成持續閱讀習慣的活動。'],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '活動',
        },
        {
          render: h(Processing, {
            content: [
              {
                id: uuid(),
                t: '與童書出版商、當地圖書館合作出產免費「閱讀禮袋」',
              },
              {
                id: uuid(),
                t: '提供家長推薦的童書清單及免費童書',
              },
              {
                id: uuid(),
                t: '指導家長培養幼兒養成閱讀習慣的方法鼓勵、參與圖書館舉辦之相關活動',
              },
            ],
          }),
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '書單類型',
        },
        {
          t: '感官動作、語文學習、認知學習、生活能力、人際互動、想像創意。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '教育部閱讀禮袋領取資格',
        },
        {
          t: [
            '1. 0-5歲嬰幼兒(民國103年1月1日以後出生)。',
            '2.戶口名簿及家長或監護人之身份證件。',
            '3.0-5歲嬰幼兒圖書館借書證。',
            '4.只要年齡在0-5歲，每一年皆可領取閱讀禮袋，至5歲為止。',
            '備註：因各縣市圖書館規定略有不同，建議先向孩子設籍所在地的圖書館詢問以取得最新訊息。',
          ],
        },
      ],
    },
  ],
};

export const retinopathyContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 350,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'senses-vision',
            label: '雷射或冷凍治療',
            mt: false,
            mb: false,
            center: true,
          }),
        },
        {
          t: [
            '1.介入時機：第三期視網膜病變(或合併有後極部血管擴張及扭曲(加重期)時)。',
            '2.作用原理：消減不正常的血管組織，以減少不正常的新生血管增生，維護視網膜後極部所負責的中心、清晰的視力。',
            '3.副作用：出現疼痛、呼吸或心跳減緩之症狀。',
            '4.合併症：可能會破壞週邊視網膜，造成日後視野較狹窄。',
          ],
        },
      ],
    },

    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'vaccination-importance',
            label: '抗血管內皮生長因子治療',
            mt: false,
            mb: false,
            center: true,
          }),
        },
        {
          t: [
            '研究顯示患有早產兒視網膜病變的眼裡有高濃度的血管內皮生長因子，若阻斷此因子，視網膜缺氧的逐漸現象改善，視網膜上的新生血管緩慢消失。',
            '1.方法：在玻璃體注射抗血管內皮生長因子以減少異常新生血管；過程相較雷射或冷凍治療簡單。',
            '2.優點：對視網膜傷害更小。',
            '3.目前趨勢：',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          render: h(HomeCareImg, {
            type: 'surgery',
            label: '手術治療',
            mt: false,
            mb: false,
            center: true,
          }),
        },
        {
          t: [
            '1.介入時機：當早產兒出現第四或第五期並有視網膜剝離。',
            '2.種類：分為鞏膜扣壓術或玻璃體切除術。',
            '3.預後：眼科醫師會視情況選擇合適手術做治療，但視力恢復的效果有限。',
          ],
        },
      ],
    },
  ],
};

export const chronicLungDiseaseTreatContent = {
  colGroup: [
    {
      id: uuid(),
      width: 150,
    },
    {
      id: uuid(),
      width: 350,
    },
  ],
  head: [],
  body: [

    {
      id: uuid(),
      texts: [
        {
          t: '肺部',
        },
        {
          t: [
            '1.呼吸道支持：維持良好心肺循環，觀察及監測呼吸狀態、膚色及血氧變化等',
            '2.提供胸腔物理治療：醫護人員應定時檢查與必要時立即予呼吸道抽吸',
            '3.使用呼吸器或氧氣支持，維持良好的血氧，避免缺氧狀況發生。',
            '4.適時訓練脫離呼吸器：固定監測血液中氣體、氧氣量以及觀察早產兒的呼吸型態調整機器設定，維持情況的穩定才能有效脫離呼吸器。',
          ],
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '腸胃',
        },
        {
          t: '避免胃食道逆流，可以降低肺部發炎的發生',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '輸液及營養',
        },
        {
          t: '可能因疾病造成肺部積水干擾呼吸，故可以減少營養針的水份攝取或是藉由提供母乳或配方奶做調整。',
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '藥物',
        },
        {
          t: '支氣管擴張劑、類固醇、利尿劑。',
        },
      ],
    },
  ],
};

export const howToPreventContent = {
  colGroup: [
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 60,
    },
    {
      id: uuid(),
      width: 100,
    },
    {
      id: uuid(),
      width: 100,
    },
  ],
  head: [],
  body: [
    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: '一、孕前準備及預防措施',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 7,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: [
            '首先諮詢婦產科以了解本身是否屬於早產高危險群、培養正確認知，盡可能消除或減低風險。',
            '1.定期且確實配合產前檢查，透過產檢及病史評估作早產高危險因子判定，並加以因應及重視。',
            '2.維持正常的妊娠時間，儘量延長胎兒在子宮內成長的時間。',
          ],
          colspan: 7,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '生活習慣',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: [
            '◎保持心情愉快。',
            '◎維持健康營養攝取。',
            '◎培養良好生活衛生習慣(勿憋尿)。',
            '◎勿抽煙、喝酒及成癮藥物使用者。',
            '◎避免久坐久站。',
            '◎減少工作壓力及工作量，勿工作過度勞累。',
            '◎避免長途勞累或提重物以增加腹壓。',
          ],
          colspan: 3,
        },
        {
          t: '生理狀況',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: [
            '◎避免青少年齡、高齡時懷孕。',
            '◎孕前避免體重過輕(<40kg)。',
            '◎懷孕間隔勿太密。',
            '◎曾人工流產。',
            '◎避免子宮頸傷害。',
            '◎有子宮頸閉鎖不全病史。',
            '◎避免醫源性(人工生殖)多胞胎。',
          ],
          colspan: 2,
        },
      ],
    },
    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: '二、了解孕期現象',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 7,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '胎動(胎兒的活動)',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '舉凡翻身﹑打嗝都算。初產婦通常胎動出現在懷孕20週左右，經產婦則在18週左右。當孕婦感覺胎動減少時，可用手輕推肚子、吃點甜食、飲料或走動刺激胎動，觀察半個小時到半天。',
          colspan: 6,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '宮縮',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '懷孕期間可能會偶爾有生理性收縮，症狀為偶發性、不規則，持續時間較短，在休息後多可緩解。正常標準為：30週以前，大約＜3次/時，30週以後，大約＜4次/時，如超過標準，請臥床休息並每天以手觸摸子宮2-3次，注意每小時收縮、變硬的次數，若仍無改善，需立即就醫。',
          colspan: 6,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '分泌物、漏尿、破水辨識',
          style: textCenter,
          tdStyle: verticalCenter,
          rowspan: 4,
        },
        {
          t: '',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '外觀',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '顏色',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '氣味',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '流量',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '破水',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '清澈',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '透明、淡黃色',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '無異味',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '持續流出',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '漏尿',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '清澈',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '黃色',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '尿意味',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '會停止',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '分泌物',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '黏稠',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '乳白色',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 2,
        },
        {
          t: '無異味',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '-',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },

    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: '三、認識早產徵兆',
          style: textCenter,
          tdStyle: verticalCenter,
          colspan: 7,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '◆胎動',
          tdStyle: verticalCenter,
        },
        {
          t: [
            '1.突然胎動劇烈。',
            '2.二小時內無胎動者。',
            '3.一天胎動少於10次。',
            '4.與平常及前一天相比，胎動次數減少50%。',
          ],
          colspan: 6,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '◆早期子宮收縮',
          tdStyle: verticalCenter,
        },
        {
          t: '異常子宮收縮是頻率規則、持續時間長，休息也無法緩解，而且子宮頸可能會軟化或擴張。每小時有5-6次以上(等於每10分鐘有1次以上)的子宮收縮。',
          colspan: 6,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: [
            '◆持續的下背痠痛或腰酸感。',
            '◆如月經來時的下腹悶痛或脹痛及腫脹。',
            '◆持續不斷的腹瀉及腸絞痛。',
            '◆腹部痙攣、或有下墜感、陰道骨盆有壓迫感(覺得好像胎兒往下推)，經臥床休息，情況仍持續沒有改善。',
            '◆破水：陰道流出清澈透明的水樣液體，或羊水突然大量流出。',
            '◆陰道分泌物增加或夾雜紅色血絲：鮮紅血狀分泌物或大量出血(約第2-3天經血量或更多)可能為產前出血，或是原有出血情形但經醫生診治後返家休息，突然出血量增加或出現血塊。',
          ],
          colspan: 7,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        {
          t: '提醒',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '懷孕過程中若有以上異常情形，請立即求治婦產科，萬一無法避免早產，建議選擇有新生兒加護病房的醫院生產，避免等到早產兒出生再轉送，容易因後送，造成體溫降低、呼吸窘迫等，產生日後的併發症。',
          colspan: 6,
        },
      ],
    },
  ],
};

export const highriskPregnantEmergencyHospitalContent = {
  colGroup: [
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
    {
      id: uuid(),
      width: 200,
    },
  ],
  head: [
    {
      id: uuid(),
      style: {
        backgroundColor: 'rgba(255, 195, 180, 0.2)',
      },
      texts: [
        {
          t: '序號',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '區域別',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '縣市別',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '醫院名稱',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '高危險妊娠及新生兒醫療處置能力',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
  ],
  body: [
    {
      id: uuid(),
      texts: [
        {
          t: '1',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '台北區',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '基隆市',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '長庚醫療財團法人基隆長庚紀念醫院',
          style: textCenter,
          tdStyle: verticalCenter,
        },
        {
          t: '重度級',
          style: textCenter,
          tdStyle: verticalCenter,
        },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '2', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '基隆市', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部基隆醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '3', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '宜蘭縣', style: textCenter, tdStyle: verticalCenter },
        { t: '醫療財團法人羅許基金會羅東博愛醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '4', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '宜蘭縣', style: textCenter, tdStyle: verticalCenter },
        { t: '國立陽明交通大學附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '5', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '宜蘭縣', style: textCenter, tdStyle: verticalCenter },
        { t: '天主教靈醫會醫療財團法人羅東聖母醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '6', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '國立台灣大學醫學院附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '7', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '醫療財團法人徐元智先生醫藥基金會亞東紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '8', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部臺北醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '9', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '輔仁大學學校財團法人輔仁大學附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '10', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市立土城醫院(委託長庚醫療財團法人興建經營)', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '11', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部雙和醫院(委託臺北醫學大學興建經營)', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '12', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市立萬芳醫院－委託財團法人臺北醫學大學辦理', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '13', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '佛教慈濟醫療財團法人台北慈濟醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '14', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '天主教耕莘醫療財團法人耕莘醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '15', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北醫學大學附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '16', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '天主教耕莘醫療財團法人永和耕莘醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '17', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '台灣基督長老教會馬偕醫療財團法人馬偕紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '18', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '台灣基督長老教會馬偕醫療財團法人淡水馬偕紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '19', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '三軍總醫院附設民眾診療服務處', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '20', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '國泰醫療財團法人國泰綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '21', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市立聯合醫院仁愛院區', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '22', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新北市', style: textCenter, tdStyle: verticalCenter },
        { t: '國泰醫療財團法人汐止國泰綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '23', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '基督復臨安息日會醫療財團法人臺安醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '24', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '長庚醫療財團法人台北長庚紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '25', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北榮民總醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '26', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '新光醫療財團法人新光吳火獅紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '27', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北市', style: textCenter, tdStyle: verticalCenter },
        { t: '振興醫療財團法人振興醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '28', style: textCenter, tdStyle: verticalCenter },
        { t: '台北區', style: textCenter, tdStyle: verticalCenter },
        { t: '金門縣', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部金門醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '29', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '桃園市', style: textCenter, tdStyle: verticalCenter },
        { t: '長庚醫療財團法人林口長庚紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '30', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新竹縣', style: textCenter, tdStyle: verticalCenter },
        { t: '東元醫療社團法人東元綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '31', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新竹縣', style: textCenter, tdStyle: verticalCenter },
        { t: '中國醫藥大學新竹附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '32', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '桃園市', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部桃園醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '33', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新竹市', style: textCenter, tdStyle: verticalCenter },
        { t: '國立臺灣大學醫學院附設醫院新竹臺大分院新竹醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '34', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新竹市', style: textCenter, tdStyle: verticalCenter },
        { t: '台灣基督長老教會馬偕醫療財團法人新竹馬偕紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '35', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '新竹縣', style: textCenter, tdStyle: verticalCenter },
        { t: '國立臺灣大學醫學院附設醫院新竹臺大分院生醫醫院竹北院區', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '36', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中榮民總醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '37', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '光田醫療社團法人光田綜合醫院沙鹿總院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '38', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '光田醫療社團法人光田綜合醫院大甲院區', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '39', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '澄清綜合醫院中港分院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '40', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '林新醫療社團法人林新醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '41', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '苗栗縣', style: textCenter, tdStyle: verticalCenter },
        { t: '李綜合醫療社團法人苑裡李綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '42', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '童綜合醫療社團法人童綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '43', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '苗栗縣', style: textCenter, tdStyle: verticalCenter },
        { t: '大千綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '44', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '苗栗縣', style: textCenter, tdStyle: verticalCenter },
        { t: '為恭醫療財團法人為恭紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '45', style: textCenter, tdStyle: verticalCenter },
        { t: '北區', style: textCenter, tdStyle: verticalCenter },
        { t: '苗栗縣', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部苗栗醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '46', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '中國醫藥大學附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '47', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '中山醫學大學附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '48', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '佛教慈濟醫療財團法人台中慈濟醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '49', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺中市', style: textCenter, tdStyle: verticalCenter },
        { t: '亞洲大學附屬醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '50', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '南投縣', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部南投醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '51', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '南投縣', style: textCenter, tdStyle: verticalCenter },
        { t: '埔基醫療財團法人埔里基督教醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '52', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '彰化縣', style: textCenter, tdStyle: verticalCenter },
        { t: '彰化基督教醫療財團法人彰化基督教醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '53', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '彰化縣', style: textCenter, tdStyle: verticalCenter },
        { t: '彰化基督教醫療財團法人員林基督教醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '54', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '彰化縣', style: textCenter, tdStyle: verticalCenter },
        { t: '秀傳醫療社團法人秀傳紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '55', style: textCenter, tdStyle: verticalCenter },
        { t: '中區', style: textCenter, tdStyle: verticalCenter },
        { t: '彰化縣', style: textCenter, tdStyle: verticalCenter },
        { t: '秀傳醫療財團法人彰濱秀傳紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '56', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '雲林縣', style: textCenter, tdStyle: verticalCenter },
        { t: '國立臺灣大學醫學院附設醫院雲林分院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '57', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '雲林縣', style: textCenter, tdStyle: verticalCenter },
        { t: '天主教若瑟醫療財團法人若瑟醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '58', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '嘉義縣', style: textCenter, tdStyle: verticalCenter },
        { t: '長庚醫療財團法人嘉義長庚紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '59', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '嘉義市', style: textCenter, tdStyle: verticalCenter },
        { t: '戴德森醫療財團法人嘉義基督教醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '60', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '嘉義縣', style: textCenter, tdStyle: verticalCenter },
        { t: '佛教慈濟醫療財團法人大林慈濟醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '61', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '嘉義市', style: textCenter, tdStyle: verticalCenter },
        { t: '天主教中華聖母修女會醫療財團法人天主教聖馬爾定醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '62', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市', style: textCenter, tdStyle: verticalCenter },
        { t: '奇美醫療財團法人奇美醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '63', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市', style: textCenter, tdStyle: verticalCenter },
        { t: '台灣基督長老教會新樓醫療財團法人麻豆新樓醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '64', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市', style: textCenter, tdStyle: verticalCenter },
        { t: '國立成功大學醫學院附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '65', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市', style: textCenter, tdStyle: verticalCenter },
        { t: '台灣基督長老教會新樓醫療財團法人台南新樓醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '66', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市', style: textCenter, tdStyle: verticalCenter },
        { t: '郭綜合醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '67', style: textCenter, tdStyle: verticalCenter },
        { t: '南區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市', style: textCenter, tdStyle: verticalCenter },
        { t: '臺南市立安南醫院-委託中國醫藥大學興建經營', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '68', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄榮民總醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '69', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '國軍高雄總醫院左營分院附設民眾診療服務處', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '70', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '澎湖縣', style: textCenter, tdStyle: verticalCenter },
        { t: '三軍總醫院澎湖分院附設民眾診療服務處', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '71', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '財團法人私立高雄醫學大學附設中和紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '72', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市立小港醫院(委託財團法人私立高雄醫學大學經營)', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '73', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '長庚醫療財團法人高雄長庚紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '74', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '義大醫療財團法人義大醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '75', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '高雄市', style: textCenter, tdStyle: verticalCenter },
        { t: '衛生福利部旗山醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '76', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '屏東縣', style: textCenter, tdStyle: verticalCenter },
        { t: '安泰醫療社團法人安泰醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '77', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '屏東縣', style: textCenter, tdStyle: verticalCenter },
        { t: '輔英科技大學附設醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '78', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '屏東縣', style: textCenter, tdStyle: verticalCenter },
        { t: '恆基醫療財團法人恆春基督教醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '79', style: textCenter, tdStyle: verticalCenter },
        { t: '高屏區', style: textCenter, tdStyle: verticalCenter },
        { t: '屏東縣', style: textCenter, tdStyle: verticalCenter },
        { t: '屏基醫療財團法人屏東基督教醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '80', style: textCenter, tdStyle: verticalCenter },
        { t: '東區', style: textCenter, tdStyle: verticalCenter },
        { t: '花蓮縣', style: textCenter, tdStyle: verticalCenter },
        { t: '佛教慈濟醫療財團法人花蓮慈濟醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '81', style: textCenter, tdStyle: verticalCenter },
        { t: '東區', style: textCenter, tdStyle: verticalCenter },
        { t: '花蓮縣', style: textCenter, tdStyle: verticalCenter },
        { t: '國軍花蓮總醫院附設民眾診療服務處', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '82', style: textCenter, tdStyle: verticalCenter },
        { t: '東區', style: textCenter, tdStyle: verticalCenter },
        { t: '花蓮縣', style: textCenter, tdStyle: verticalCenter },
        { t: '臺北榮民總醫院玉里分院', style: textCenter, tdStyle: verticalCenter },
        { t: '中度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
    {
      id: uuid(),
      texts: [
        { t: '83', style: textCenter, tdStyle: verticalCenter },
        { t: '東區', style: textCenter, tdStyle: verticalCenter },
        { t: '臺東縣', style: textCenter, tdStyle: verticalCenter },
        { t: '台灣基督長老教會馬偕醫療財團法人台東馬偕紀念醫院', style: textCenter, tdStyle: verticalCenter },
        { t: '重度級', style: textCenter, tdStyle: verticalCenter },
      ],
    },
  ],
};
